import getTypeFromUri from './get-type-from-uri';

export function getColorForGenreUri(uri) {
  const name = uri?.match(/[^:]+$/)?.[0]?.toLowerCase();
  if (getTypeFromUri(uri) !== 'genre' || !name) return null;

  if (name in colorByGenreName) return colorByGenreName[name];
  if (name in browseGenreByMicrogenre)
    return colorByGenreName[browseGenreByMicrogenre[name]];

  let leadingNormalizationName = name;
  let trailingNormalizationName = name;
  let lastLeadingNormalizationName;
  let lastTrailingNormalizationName;

  do {
    lastLeadingNormalizationName = leadingNormalizationName;
    leadingNormalizationName = leadingNormalizationName.replace(/^\S+\s/, '');

    lastTrailingNormalizationName = trailingNormalizationName;
    trailingNormalizationName = trailingNormalizationName.replace(/\s\S+$/, '');

    if (leadingNormalizationName in browseGenreByMicrogenre)
      return colorByGenreName[
        browseGenreByMicrogenre[leadingNormalizationName]
      ];
    if (trailingNormalizationName in browseGenreByMicrogenre)
      return colorByGenreName[
        browseGenreByMicrogenre[trailingNormalizationName]
      ];
    if (leadingNormalizationName in colorByGenreName)
      return colorByGenreName[leadingNormalizationName];
    if (trailingNormalizationName in colorByGenreName)
      return colorByGenreName[trailingNormalizationName];
  } while (
    leadingNormalizationName !== lastLeadingNormalizationName ||
    trailingNormalizationName !== lastTrailingNormalizationName
  );

  return null;
}

const colorByGenreName = {
  afro: '#c39687',
  arab: '#509bf5',
  arabic: '#509bf5',
  blues: '#a0c3d2',
  bollywood: '#ff4632',
  brazilian: '#ffc864',
  cantopop: '#b49bc8',
  chill: '#a0c3d2',
  classical: '#b49bc8',
  colombian: '#ff6437',
  comedy: '#f037a5',
  country: '#ffc864',
  danish: '#006450',
  dansband: '#8c1932',
  desi: '#ffc864',
  dinner: '#ffc864',
  dutch: '#ff4632',
  edm_dance: '#9bf0e1',
  edm: '#9bf0e1',
  dance: '#9bf0e1',
  focus: '#b49bc8',
  francophone: '#a0c3d2',
  french_variety: '#2d46b9',
  funk: '#f037a5',
  funkbrazil: '#2d46b9',
  gaming: '#ff6437',
  hiphop: '#f59b23',
  indie_alt: '#4100f5',
  inspirational: '#509bf5',
  j_tracks: '#af2896',
  jazz: '#a0c3d2',
  karaoke: '#ff6437',
  khaleeji: '#8c1932',
  kids: '#af2896',
  kpop: '#cdf564',
  latin: '#ff6437',
  mandopop: '#a0c3d2',
  metal: '#6F6F6F',
  mexican: '#006450',
  opm: '#f573a0',
  party: '#f037a5',
  pop: '#c3f0c8',
  punjabi: '#af2896',
  punk: '#6F6F6F',
  reggae: '#006450',
  rnb: '#f037a5',
  rock: '#eb1e32',
  romance: '#f573a0',
  roots: '#4b917d',
  sertanejo: '#c39687',
  sleep: '#a0c3d2',
  soul: '#f037a5',
  tamil: '#ffc864',
  telugu: '#19e68c',
  thai: '#ff4632',
  vietnamese: '#c3f0c8',
  word: '#f573a0',
  workout: '#ffc864',
};

const browseGenreByMicrogenre = {
  '21st century classical': 'classical',
  '432hz': 'background',
  '8-bit': 'electronic',
  'a cappella': 'pop',
  'aarhus indie': 'indie_alt',
  'aberdeen indie': 'indie_alt',
  'abstract beats': 'atmospheric',
  'abstract hip hop': 'hiphop',
  'abstract idm': 'atmospheric',
  'acid house': 'edm_dance',
  'acid idm': 'edm_dance',
  'acid jazz': 'jazz',
  'acid rock': 'rock',
  'acid techno': 'edm_dance',
  'acid trance': 'edm_dance',
  'acoustic blues': 'blues',
  'acoustic chill': 'background',
  'acoustic guitar cover': 'atmospheric',
  'acoustic opm': 'pop',
  'acoustic pop': 'pop',
  'acoustic punk': 'punk',
  'acoustic rock': 'rock',
  'action rock': 'rock',
  'adelaide indie': 'indie_alt',
  'adult standards': 'oldies',
  'afghan pop': 'pop',
  'afghan traditional': 'roots',
  'african electronic': 'indie_alt',
  'african experimental': 'atmospheric',
  'african gospel': 'inspirational',
  'african metal': 'metal',
  'african percussion': 'roots',
  'african reggae': 'reggae',
  'african rock': 'rock',
  'african-american classical': 'classical',
  'afrikaans folk': 'pop',
  'afrikaans gospel': 'inspirational',
  'afro dancehall': 'hiphop',
  'afro house': 'edm_dance',
  'afro psych': 'rock',
  'afro r&b': 'afro',
  'afro soul': 'soul',
  'afro-cuban traditional': 'roots',
  'afro-funk': 'soul',
  'afrobeat brasileiro': 'brazilian',
  'afrofuturismo brasileiro': 'brazilian',
  'aggro chileno': 'metal',
  'aghani lil-atfal': 'children',
  'ainu folk': 'roots',
  'alabama indie': 'indie_alt',
  'alabama metal': 'metal',
  'alabama rap': 'hiphop',
  'alaska indie': 'indie_alt',
  'albanian folk': 'roots',
  'albanian hip hop': 'hiphop',
  'albanian iso polyphony': 'roots',
  'albanian pop': 'pop',
  'albany ny indie': 'indie_alt',
  'alberta country': 'country',
  'alberta hip hop': 'hiphop',
  'album rock': 'rock',
  'albuquerque indie': 'indie_alt',
  'algerian folk': 'roots',
  'alpine yodeling': 'roots',
  'alt-idol': 'j_tracks',
  'alternative americana': 'folk_americana',
  'alternative ccm': 'inspirational',
  'alternative country': 'folk_americana',
  'alternative dance': 'indie_alt',
  'alternative emo': 'indie_alt',
  'alternative hardcore': 'punk',
  'alternative hip hop': 'hiphop',
  'alternative metal': 'rock',
  'alternative metalcore': 'rock',
  'alternative pop rock': 'indie_alt',
  'alternative pop': 'indie_alt',
  'alternative r&b': 'rnb',
  'alternative rock': 'indie_alt',
  'alternative roots rock': 'indie_alt',
  'ambient black metal': 'metal',
  'ambient dub techno': 'atmospheric',
  'ambient folk': 'folk_americana',
  'ambient fusion': 'atmospheric',
  'ambient house': 'electronic',
  'ambient idm': 'atmospheric',
  'ambient industrial': 'atmospheric',
  'ambient pop': 'atmospheric',
  'ambient psychill': 'atmospheric',
  'ambient techno': 'electronic',
  'ambient trance': 'edm_dance',
  'ambient worship': 'inspirational',
  'american 21st century classical': 'classical',
  'american choir': 'classical',
  'american classical piano': 'classical',
  'american contemporary classical': 'classical',
  'american early music': 'classical',
  'american folk revival': 'folk_americana',
  'american metalcore': 'rock',
  'american modern classical': 'classical',
  'american oi': 'punk',
  'american orchestra': 'classical',
  'american post-rock': 'rock',
  'american primitive': 'folk_americana',
  'american romanticism': 'classical',
  'american shoegaze': 'indie_alt',
  'amharic pop': 'afro',
  'anadolu rock': 'rock',
  'anarcho-punk': 'punk',
  'ancient mediterranean': 'roots',
  'andalusian classical': 'roots',
  'andean flute': 'roots',
  'anglican liturgy': 'classical',
  'animal singing': 'background',
  'anime cv': 'pop',
  'anime latino': 'latin',
  'anime rock': 'j_tracks',
  'anime score': 'j_tracks',
  'ann arbor indie': 'indie_alt',
  'anthem emo': 'indie_alt',
  'anthem worship': 'inspirational',
  'anti-folk': 'folk_americana',
  'antilliaanse folklore': 'roots',
  'antilliaanse rap': 'hiphop',
  'antiviral pop': 'comedy',
  'apostolic worship': 'inspirational',
  'appalachian folk': 'folk_americana',
  'appenzeller folk': 'roots',
  'arab alternative': 'indie_alt',
  'arab electronic': 'electronic',
  'arab folk': 'roots',
  'arab groove': 'pop',
  'arab metal': 'metal',
  'arab pop': 'pop',
  'arab trap': 'edm_dance',
  'arabic hip hop': 'hiphop',
  'arabic jazz': 'jazz',
  'arabic pop': 'arabic',
  'argentine alternative rock': 'rock',
  'argentine ambient': 'atmospheric',
  'argentine hardcore': 'latin',
  'argentine heavy metal': 'metal',
  'argentine hip hop': 'hiphop',
  'argentine indie rock': 'indie_alt',
  'argentine indie': 'latin',
  'argentine jazz': 'jazz',
  'argentine metal': 'metal',
  'argentine punk': 'latin',
  'argentine reggae': 'reggae',
  'argentine rock': 'latin',
  'argentine telepop': 'latin',
  'arizona punk': 'punk',
  'arkansas country': 'country',
  'arkansas hip hop': 'hiphop',
  'arkansas indie': 'indie_alt',
  'armenian folk': 'roots',
  'armenian pop': 'pop',
  'arpa grande': 'roots',
  'arpa paraguaya': 'roots',
  'ars subtilior': 'classical',
  'art pop': 'indie_alt',
  'art punk': 'punk',
  'art rock': 'rock',
  'art song': 'classical',
  'asbury park indie': 'indie_alt',
  'asheville indie': 'indie_alt',
  'asian american hip hop': 'hiphop',
  'assyrian pop': 'pop',
  'athens indie': 'indie_alt',
  'atl hip hop': 'hiphop',
  'atl trap': 'hiphop',
  'atlanta indie': 'indie_alt',
  'atlanta metal': 'metal',
  'atlanta punk': 'punk',
  'atmospheric black metal': 'metal',
  'atmospheric dnb': 'edm_dance',
  'atmospheric doom': 'metal',
  'atmospheric post-metal': 'metal',
  'atmospheric post-rock': 'atmospheric',
  'atmospheric sludge': 'metal',
  'auckland indie': 'indie_alt',
  'audiophile vocal': 'jazz',
  'aussie drill': 'hiphop',
  'aussie emo': 'punk',
  'austin americana': 'folk_americana',
  'austin hip hop': 'hiphop',
  'austin rock': 'rock',
  'austin singer-songwriter': 'pop',
  'australian alternative pop': 'pop',
  'australian alternative rock': 'rock',
  'australian ambient': 'atmospheric',
  'australian americana': 'roots',
  'australian black metal': 'metal',
  'australian blues': 'blues',
  'australian choir': 'classical',
  'australian classical piano': 'classical',
  'australian classical': 'classical',
  'australian comedy': 'spoken',
  'australian country': 'country',
  'australian dance': 'edm_dance',
  'australian electropop': 'pop',
  'australian experimental': 'atmospheric',
  'australian garage punk': 'punk',
  'australian hardcore': 'punk',
  'australian hip hop': 'hiphop',
  'australian house': 'edm_dance',
  'australian indie folk': 'indie_alt',
  'australian indie rock': 'indie_alt',
  'australian indie': 'indie_alt',
  'australian indigenous': 'roots',
  'australian jazz': 'jazz',
  'australian metal': 'metal',
  'australian metalcore': 'rock',
  'australian pop': 'pop',
  'australian post-hardcore': 'indie_alt',
  'australian post-punk': 'rock',
  'australian post-rock': 'rock',
  'australian psych': 'rock',
  'australian r&b': 'rnb',
  'australian reggae fusion': 'reggae',
  'australian rock': 'rock',
  'australian rockabilly': 'rock',
  'australian shoegaze': 'rock',
  'australian singer-songwriter': 'folk_americana',
  'australian ska': 'pop',
  'australian talent show': 'pop',
  'australian techno': 'edm_dance',
  'australian thrash metal': 'metal',
  'australian trap': 'hiphop',
  'australian underground hip hop': 'hiphop',
  'austrian black metal': 'metal',
  'austrian choir': 'classical',
  'austrian classical piano': 'classical',
  'austrian contemporary classical': 'classical',
  'austrian dnb': 'edm_dance',
  'austrian hip hop': 'hiphop',
  'austrian indie': 'indie_alt',
  'austrian jazz': 'jazz',
  'austrian metal': 'metal',
  'austrian orchestra': 'classical',
  'austrian pop': 'pop',
  'austrian punk': 'punk',
  'austrian stoner rock': 'rock',
  'austrian techno': 'edm_dance',
  'austro-german modernism': 'classical',
  'autonomous black metal': 'metal',
  'avant-garde black metal': 'metal',
  'avant-garde jazz': 'jazz',
  'avant-garde metal': 'metal',
  'avant-garde': 'atmospheric',
  'avant-rock': 'rock',
  'azeri pop': 'pop',
  'azeri rap': 'hiphop',
  'azeri traditional': 'roots',
  'bachata dominicana': 'latin',
  'background music': 'background',
  'background piano': 'background',
  'backing track': 'background',
  'bagpipe marching band': 'roots',
  'bahamian folk': 'roots',
  'bahamian pop': 'pop',
  'baile funk': 'funkbrazil',
  'baithak gana': 'pop',
  'baja indie': 'indie_alt',
  'bakersfield sound': 'country',
  'bal-musette': 'french_variety',
  'balkan brass': 'roots',
  'balkan classical piano': 'classical',
  'balkan folk metal': 'metal',
  'balkan hip hop': 'hiphop',
  'balkan trap': 'hiphop',
  'ballet class': 'background',
  'baltic black metal': 'metal',
  'baltic choir': 'roots',
  'baltic classical piano': 'classical',
  'baltic classical': 'classical',
  'baltic folk': 'roots',
  'baltimore hip hop': 'hiphop',
  'baltimore indie': 'indie_alt',
  'baluchi folk': 'roots',
  'band organ': 'oldies',
  'banda caliente': 'regionalmexican',
  'banda carnavalera': 'latin',
  'bangalore indie': 'desi',
  'bangladeshi hip hop': 'hiphop',
  'bangladeshi indie': 'pop',
  'bangladeshi rock': 'rock',
  'baptist gospel': 'inspirational',
  'barbadian pop': 'pop',
  'baroque brass': 'classical',
  'baroque cello': 'classical',
  'baroque ensemble': 'classical',
  'baroque pop': 'pop',
  'baroque singing': 'classical',
  'baroque violin': 'classical',
  'baroque woodwind': 'classical',
  'basel indie': 'indie_alt',
  'basque folk': 'roots',
  'bass house': 'edm_dance',
  'bass music': 'edm_dance',
  'bass trap': 'edm_dance',
  'bass trip': 'edm_dance',
  'bath indie': 'indie_alt',
  'batidao romantico': 'brazilian',
  'baton rouge indie': 'indie_alt',
  'baton rouge rap': 'hiphop',
  'battle rap': 'hiphop',
  'bay area hip hop': 'hiphop',
  'bay area indie': 'indie_alt',
  'bayerischer rap': 'hiphop',
  'bc underground hip hop': 'hiphop',
  'beach house': 'edm_dance',
  'beach music': 'oldies',
  'beat italiano': 'oldies',
  'beat poetry': 'spoken',
  'bedroom pop': 'indie_alt',
  'bedroom soul': 'soul',
  'belarusian electronic': 'electronic',
  'belarusian hip hop': 'hiphop',
  'belarusian indie': 'indie_alt',
  'belarusian metal': 'metal',
  'belarusian pop': 'pop',
  'belarusian punk': 'punk',
  'belarusian rock': 'rock',
  'belfast indie': 'indie_alt',
  'belfast metal': 'metal',
  'belgian black metal': 'metal',
  'belgian blues': 'blues',
  'belgian classical piano': 'classical',
  'belgian contemporary classical': 'classical',
  'belgian dance': 'edm_dance',
  'belgian death metal': 'metal',
  'belgian edm': 'edm_dance',
  'belgian experimental': 'atmospheric',
  'belgian hardcore': 'punk',
  'belgian hip hop': 'hiphop',
  'belgian indie rock': 'rock',
  'belgian indie': 'indie_alt',
  'belgian jazz': 'jazz',
  'belgian metal': 'metal',
  'belgian modern jazz': 'jazz',
  'belgian new wave': 'pop',
  'belgian pop': 'pop',
  'belgian post-rock': 'rock',
  'belgian punk': 'punk',
  'belgian rock': 'rock',
  'belgian singer-songwriter': 'pop',
  'belgian stoner rock': 'rock',
  'belgian techno': 'edm_dance',
  'belly dance': 'roots',
  'belo horizonte indie': 'indie_alt',
  'bengali folk': 'roots',
  'beninese pop': 'afro',
  'bergamo indie': 'pop',
  'bergen indie': 'pop',
  'berlin minimal techno': 'edm_dance',
  'berlin school': 'electronic',
  'bern indie': 'indie_alt',
  'bernu dziesmas': 'children',
  'big band': 'jazz',
  'big beat': 'edm_dance',
  'big room': 'edm_dance',
  'birmingham grime': 'hiphop',
  'birmingham hip hop': 'hiphop',
  'birmingham indie': 'indie_alt',
  'birmingham metal': 'metal',
  'bisaya indie': 'pop',
  'bisaya rap': 'hiphop',
  'black comedy': 'spoken',
  'black death': 'metal',
  'black metal argentino': 'metal',
  'black metal': 'metal',
  'black noise': 'metal',
  'black punk': 'punk',
  'black sludge': 'metal',
  'black speed metal': 'metal',
  'black thrash': 'metal',
  'blackened crust': 'metal',
  'blackened hardcore': 'punk',
  'bleep techno': 'edm_dance',
  'bluegrass fiddle': 'folk_americana',
  'bluegrass gospel': 'folk_americana',
  'blues band': 'blues',
  'blues latinoamericano': 'latin',
  'blues mexicano': 'blues',
  'blues rock': 'rock',
  'blues-rock guitar': 'rock',
  'bogor indie': 'pop',
  'bohemian baroque': 'classical',
  'bohol indie': 'pop',
  'bolero cubano': 'latin',
  'bolivian metal': 'metal',
  'bolivian rock': 'latin',
  'bongo flava': 'afro',
  'boogie-woogie': 'blues',
  'boom bap brasileiro': 'brazilian',
  'boom bap': 'hiphop',
  'bosnian electronic': 'electronic',
  'bosnian indie': 'indie_alt',
  'bossa nova cover': 'pop',
  'bossa nova jazz': 'brazilian',
  'bossa nova': 'brazilian',
  'boston electronic': 'electronic',
  'boston folk': 'folk_americana',
  'boston hardcore': 'punk',
  'boston hip hop': 'hiphop',
  'boston indie': 'indie_alt',
  'boston metal': 'metal',
  'boston punk': 'punk',
  'boston rock': 'indie_alt',
  'bothy ballad': 'roots',
  'botswana pop': 'pop',
  'bouncy house': 'edm_dance',
  'boy band': 'pop',
  'boy pop': 'pop',
  'boy soprano': 'roots',
  'brain waves': 'background',
  'brasilia indie': 'brazilian',
  'brass band brasileiro': 'brazilian',
  'brass band': 'roots',
  'brass ensemble': 'classical',
  'brass quintet': 'roots',
  'brazilian bass': 'edm_dance',
  'brazilian black metal': 'metal',
  'brazilian blues': 'brazilian',
  'brazilian boogie': 'brazilian',
  'brazilian ccm': 'inspirational',
  'brazilian classical piano': 'classical',
  'brazilian classical': 'classical',
  'brazilian contemporary classical': 'classical',
  'brazilian death metal': 'brazilian',
  'brazilian doom metal': 'brazilian',
  'brazilian edm': 'edm_dance',
  'brazilian emo': 'brazilian',
  'brazilian experimental': 'brazilian',
  'brazilian gospel': 'inspirational',
  'brazilian grindcore': 'brazilian',
  'brazilian groove metal': 'brazilian',
  'brazilian hardcore': 'brazilian',
  'brazilian heavy metal': 'brazilian',
  'brazilian hip hop': 'brazilian',
  'brazilian house': 'brazilian',
  'brazilian indie rock': 'brazilian',
  'brazilian indie': 'brazilian',
  'brazilian jazz': 'brazilian',
  'brazilian lo-fi rock': 'brazilian',
  'brazilian metal': 'metal',
  'brazilian metalcore': 'brazilian',
  'brazilian modern jazz': 'brazilian',
  'brazilian percussion': 'brazilian',
  'brazilian post-hardcore': 'brazilian',
  'brazilian post-rock': 'brazilian',
  'brazilian power metal': 'brazilian',
  'brazilian progressive metal': 'brazilian',
  'brazilian punk rock': 'brazilian',
  'brazilian punk': 'brazilian',
  'brazilian reggae': 'reggae',
  'brazilian rock': 'rock',
  'brazilian rockabilly': 'brazilian',
  'brazilian ska': 'brazilian',
  'brazilian soul': 'brazilian',
  'brazilian stoner rock': 'brazilian',
  'brazilian surf rock': 'brazilian',
  'brazilian tech house': 'edm_dance',
  'brazilian techno': 'edm_dance',
  'brazilian thrash metal': 'brazilian',
  'brega funk': 'brazilian',
  'brega romantico': 'brazilian',
  'breton folk': 'roots',
  'brighton indie': 'indie_alt',
  'brill building pop': 'oldies',
  'brisbane indie': 'indie_alt',
  'bristol electronic': 'electronic',
  'bristol indie': 'indie_alt',
  'brit funk': 'soul',
  'british alternative rock': 'indie_alt',
  'british black metal': 'metal',
  'british blues': 'blues',
  'british brass band': 'oldies',
  'british choir': 'classical',
  'british classical piano': 'classical',
  'british comedy': 'spoken',
  'british contemporary classical': 'classical',
  'british country': 'country',
  'british dance band': 'oldies',
  'british death metal': 'metal',
  'british electroacoustic': 'electronic',
  'british experimental': 'atmospheric',
  'british folk': 'folk_americana',
  'british grindcore': 'metal',
  'british indie rock': 'indie_alt',
  'british industrial': 'rock',
  'british invasion': 'oldies',
  'british jazz': 'jazz',
  'british math rock': 'rock',
  'british modern classical': 'classical',
  'british orchestra': 'classical',
  'british post-rock': 'rock',
  'british power metal': 'metal',
  'british singer-songwriter': 'pop',
  'british soul': 'soul',
  'british soundtrack': 'soundtrack',
  'brockton hip hop': 'hiphop',
  'broken beat': 'edm_dance',
  'bronx hip hop': 'hiphop',
  'brooklyn drill': 'hiphop',
  'brooklyn indie': 'indie_alt',
  'brutal death metal': 'metal',
  'brutal deathcore': 'metal',
  'bubble trance': 'edm_dance',
  'bubblegum dance': 'edm_dance',
  'bubblegum pop': 'pop',
  'buffalo hip hop': 'hiphop',
  'buffalo ny indie': 'indie_alt',
  'buffalo ny metal': 'metal',
  'bulgarian electronic': 'electronic',
  'bulgarian experimental': 'atmospheric',
  'bulgarian folk': 'roots',
  'bulgarian hip hop': 'hiphop',
  'bulgarian indie': 'pop',
  'bulgarian metal': 'metal',
  'bulgarian pop': 'pop',
  'bulgarian rock': 'rock',
  'burkinabe pop': 'afro',
  'burkinabe traditional': 'roots',
  'burmese pop': 'pop',
  'burmese traditional': 'roots',
  'burundian pop': 'afro',
  'burundian traditional': 'roots',
  'bury st edmunds indie': 'indie_alt',
  'bush ballad': 'roots',
  'c-pop': 'pop',
  'calgary indie': 'indie_alt',
  'cali rap': 'hiphop',
  'calming instrumental': 'background',
  'cambodian rock': 'rock',
  'cambodian traditional': 'roots',
  'cambridge choir': 'roots',
  'cambridgeshire indie': 'indie_alt',
  'cameroonian pop': 'afro',
  'canadian americana': 'folk_americana',
  'canadian black metal': 'metal',
  'canadian blues': 'blues',
  'canadian ccm': 'inspirational',
  'canadian celtic': 'roots',
  'canadian choir': 'classical',
  'canadian classical piano': 'classical',
  'canadian classical': 'classical',
  'canadian comedy': 'spoken',
  'canadian contemporary country': 'country',
  'canadian contemporary r&b': 'rnb',
  'canadian country': 'country',
  'canadian electronic': 'edm_dance',
  'canadian electropop': 'pop',
  'canadian experimental': 'atmospheric',
  'canadian folk': 'folk_americana',
  'canadian garage rock': 'rock',
  'canadian hardcore': 'punk',
  'canadian hip hop': 'hiphop',
  'canadian house': 'edm_dance',
  'canadian indie folk': 'indie_alt',
  'canadian indie': 'rock',
  'canadian indigenous hip hop': 'hiphop',
  'canadian indigenous': 'roots',
  'canadian latin': 'pop',
  'canadian metal': 'metal',
  'canadian metalcore': 'rock',
  'canadian modern jazz': 'jazz',
  'canadian pop punk': 'punk',
  'canadian pop': 'pop',
  'canadian post-hardcore': 'rock',
  'canadian post-punk': 'rock',
  'canadian post-rock': 'rock',
  'canadian psychedelic rock': 'rock',
  'canadian psychedelic': 'rock',
  'canadian punk': 'punk',
  'canadian rock': 'rock',
  'canadian rockabilly': 'rock',
  'canadian shoegaze': 'indie_alt',
  'canadian singer-songwriter': 'pop',
  'canadian soundtrack': 'soundtrack',
  'canadian stoner rock': 'rock',
  'canberra indie': 'indie_alt',
  'cancion infantil mexicana': 'children',
  'cancion melodica': 'pop',
  'cancoes infantis': 'children',
  'candy pop': 'pop',
  'cantautor catala': 'pop',
  'cante alentejano': 'roots',
  'cante flamenco': 'roots',
  'canterbury scene': 'oldies',
  'canti alpini': 'roots',
  'canto a tenore': 'roots',
  'canto popular uruguayo': 'roots',
  'cantonese traditional': 'roots',
  'canzone genovese': 'pop',
  'canzone napoletana': 'roots',
  'cape breton folk': 'roots',
  'cape breton indie': 'pop',
  'cape town indie': 'indie_alt',
  'cape verdean folk': 'roots',
  'caracas indie': 'indie_alt',
  'cardiff indie': 'indie_alt',
  'caribbean metal': 'metal',
  'carnatic instrumental': 'roots',
  'carnatic vocal': 'roots',
  'carnaval cadiz': 'roots',
  'carnaval limburg': 'pop',
  'cascadian black metal': 'metal',
  'catalan folk': 'roots',
  'cathedral choir': 'inspirational',
  'caucasian classical piano': 'classical',
  'caucasian classical': 'classical',
  'caucasian folk': 'roots',
  'cavernous death metal': 'metal',
  'cdmx indie': 'indie_alt',
  'celtic harp': 'roots',
  'celtic metal': 'metal',
  'celtic punk': 'punk',
  'celtic rock': 'rock',
  'central american metal': 'metal',
  'central asian folk': 'roots',
  'cerkes muzikleri': 'pop',
  'cha-cha-cha': 'pop',
  'chaabi algerien': 'arabic',
  'chaabi marocain': 'pop',
  'chamame brasilero': 'brazilian',
  'chamber choir': 'classical',
  'chamber ensemble': 'classical',
  'chamber folk': 'indie_alt',
  'chamber orchestra': 'classical',
  'chamber pop': 'indie_alt',
  'chamber psych': 'indie_alt',
  'channel islands indie': 'indie_alt',
  'channel pop': 'pop',
  'chanson paillarde': 'french_variety',
  'chanson quebecois': 'francophone',
  'chant basque': 'roots',
  'chant religieux': 'inspirational',
  'chaotic black metal': 'metal',
  'chaotic hardcore': 'punk',
  'charlotte nc indie': 'indie_alt',
  'charlottesville indie': 'indie_alt',
  'charred death': 'metal',
  'chattanooga indie': 'indie_alt',
  'chechen pop': 'pop',
  'chennai indie': 'desi',
  'chicago blues': 'blues',
  'chicago drill': 'hiphop',
  'chicago hardcore': 'punk',
  'chicago house': 'edm_dance',
  'chicago indie': 'indie_alt',
  'chicago pop punk': 'punk',
  'chicago punk': 'punk',
  'chicago rap': 'hiphop',
  'chicago soul': 'soul',
  'chicano punk': 'punk',
  'chicano rap': 'hiphop',
  'chihuahua indie': 'indie_alt',
  'chilean black metal': 'metal',
  'chilean hardcore': 'latin',
  'chilean indie': 'latin',
  'chilean metal': 'metal',
  'chilean rock': 'latin',
  'chill baile': 'brazilian',
  'chill beats': 'electronic',
  'chill groove': 'background',
  'chill guitar': 'background',
  'chill lounge': 'background',
  'chill out': 'background',
  'chill pop': 'pop',
  'chill r&b': 'indie_alt',
  'chill-out trance': 'edm_dance',
  'chinese audiophile': 'pop',
  'chinese classical performance': 'classical',
  'chinese classical piano': 'classical',
  'chinese classical': 'classical',
  'chinese drama ost': 'pop',
  'chinese electronic': 'electronic',
  'chinese electropop': 'pop',
  'chinese experimental': 'atmospheric',
  'chinese folk': 'pop',
  'chinese hip hop': 'hiphop',
  'chinese idol pop': 'pop',
  'chinese indie rock': 'rock',
  'chinese indie': 'indie_alt',
  'chinese instrumental': 'roots',
  'chinese jazz': 'jazz',
  'chinese manyao': 'pop',
  'chinese metal': 'metal',
  'chinese minyao': 'roots',
  'chinese new year': 'pop',
  'chinese opera': 'roots',
  'chinese post-punk': 'rock',
  'chinese post-rock': 'rock',
  'chinese punk': 'punk',
  'chinese r&b': 'pop',
  'chinese soundtrack': 'soundtrack',
  'chinese traditional': 'roots',
  'chinese viral pop': 'pop',
  'chinese worship': 'inspirational',
  'chip hop': 'hiphop',
  'chopped and screwed': 'hiphop',
  'choro contemporaneo': 'brazilian',
  'christchurch indie': 'indie_alt',
  'christian a cappella': 'inspirational',
  'christian afrobeat': 'inspirational',
  'christian alternative rock': 'inspirational',
  'christian dance': 'inspirational',
  'christian deathcore': 'metal',
  'christian hard rock': 'inspirational',
  'christian hardcore': 'inspirational',
  'christian hip hop': 'inspirational',
  'christian indie': 'inspirational',
  'christian metal': 'inspirational',
  'christian metalcore': 'inspirational',
  'christian music': 'inspirational',
  'christian pop': 'inspirational',
  'christian power metal': 'inspirational',
  'christian punk': 'inspirational',
  'christian relaxative': 'inspirational',
  'christian rock': 'inspirational',
  'christian symphonic metal': 'inspirational',
  'christian thrash metal': 'inspirational',
  'christian trap': 'inspirational',
  'christian uplift': 'inspirational',
  'christlicher rap': 'inspirational',
  'christmas instrumental': 'background',
  'christmas product': 'background',
  'cincinnati indie': 'indie_alt',
  'cincinnati rap': 'hiphop',
  'cinematic dubstep': 'edm_dance',
  'cinematic post-rock': 'rock',
  'circassian folk': 'roots',
  'classic afrobeat': 'roots',
  'classic arab pop': 'pop',
  'classic arabic pop': 'arabic',
  'classic australian country': 'country',
  'classic belgian pop': 'pop',
  'classic bhangra': 'pop',
  'classic bollywood': 'bollywood',
  'classic bulgarian pop': 'pop',
  'classic canadian rock': 'rock',
  'classic cantopop': 'pop',
  'classic colombian pop': 'colombian',
  'classic country pop': 'country',
  'classic czech pop': 'pop',
  'classic danish pop': 'danish',
  'classic danish rock': 'rock',
  'classic dubstep': 'edm_dance',
  'classic dutch pop': 'dutch',
  'classic eurovision': 'pop',
  'classic finnish pop': 'pop',
  'classic finnish rock': 'rock',
  'classic french pop': 'french_variety',
  'classic garage rock': 'rock',
  'classic girl group': 'oldies',
  'classic greek pop': 'pop',
  'classic greek rock': 'rock',
  'classic hardstyle': 'edm_dance',
  'classic hungarian pop': 'pop',
  'classic hungarian rock': 'rock',
  'classic icelandic pop': 'oldies',
  'classic indo pop': 'pop',
  'classic iskelma': 'pop',
  'classic israeli pop': 'pop',
  'classic italian folk pop': 'roots',
  'classic italian pop': 'pop',
  'classic j-rock': 'j_tracks',
  'classic japanese jazz': 'j_tracks',
  'classic korean pop': 'pop',
  'classic latvian pop': 'pop',
  'classic luk thung': 'roots',
  'classic malaysian pop': 'pop',
  'classic mandopop': 'pop',
  'classic moroccan pop': 'pop',
  'classic nepali pop': 'roots',
  'classic norwegian pop': 'pop',
  'classic nz country': 'country',
  'classic nz pop': 'pop',
  'classic opm': 'pop',
  'classic pakistani pop': 'pop',
  'classic persian pop': 'pop',
  'classic peruvian pop': 'latin',
  'classic polish pop': 'pop',
  'classic portuguese pop': 'pop',
  'classic praise': 'inspirational',
  'classic progressive house': 'edm_dance',
  'classic psychedelic rock': 'rock',
  'classic punjabi pop': 'desi',
  'classic rock': 'rock',
  'classic russian pop': 'oldies',
  'classic russian rock': 'rock',
  'classic schlager': 'oldies',
  'classic sinhala pop': 'roots',
  'classic soul': 'soul',
  'classic soundtrack': 'soundtrack',
  'classic swedish pop': 'pop',
  'classic thai pop': 'pop',
  'classic tunisian pop': 'pop',
  'classic turkish pop': 'oldies',
  'classic uk pop': 'oldies',
  'classic venezuelan pop': 'oldies',
  'classical accordion': 'classical',
  'classical baritone': 'classical',
  'classical bass': 'classical',
  'classical bassoon': 'classical',
  'classical cello': 'classical',
  'classical clarinet': 'classical',
  'classical contralto': 'classical',
  'classical countertenor': 'classical',
  'classical era': 'classical',
  'classical flute': 'classical',
  'classical guitar duo': 'classical',
  'classical guitar quartet': 'classical',
  'classical guitar': 'classical',
  'classical harp': 'classical',
  'classical horn': 'classical',
  'classical jazz fusion': 'jazz',
  'classical mandolin': 'classical',
  'classical mezzo-soprano': 'classical',
  'classical oboe': 'classical',
  'classical organ': 'classical',
  'classical percussion': 'classical',
  'classical performance': 'classical',
  'classical piano duo': 'classical',
  'classical piano trio': 'classical',
  'classical piano': 'classical',
  'classical saxophone quartet': 'classical',
  'classical saxophone': 'classical',
  'classical soprano': 'classical',
  'classical string trio': 'classical',
  'classical tenor': 'classical',
  'classical trombone': 'classical',
  'classical trumpet': 'classical',
  'classical tuba': 'classical',
  'clawhammer banjo': 'folk_americana',
  'clean comedy': 'spoken',
  'cleveland indie': 'indie_alt',
  'cleveland metal': 'metal',
  'cocuk sarkilari': 'children',
  'collage pop': 'indie_alt',
  'college a cappella': 'pop',
  'college marching band': 'roots',
  'cologne electronic': 'electronic',
  'cologne hip hop': 'hiphop',
  'cologne indie': 'indie_alt',
  'colombian black metal': 'metal',
  'colombian electronic': 'electronic',
  'colombian hardcore': 'latin',
  'colombian hip hop': 'colombian',
  'colombian indie': 'indie_alt',
  'colombian pop': 'colombian',
  'colombian rock': 'colombian',
  'colorado hardcore': 'punk',
  'columbus ohio indie': 'indie_alt',
  'combos nacionales': 'latin',
  'comedy rap': 'hiphop',
  'comedy rock': 'comedy',
  'comic metal': 'metal',
  'compositional ambient': 'atmospheric',
  'concepcion indie': 'indie_alt',
  'concert band': 'classical',
  'congolese gospel': 'inspirational',
  'connecticut hardcore': 'punk',
  'connecticut indie': 'indie_alt',
  'conscious hip hop': 'hiphop',
  'contemporary choir': 'classical',
  'contemporary classical piano': 'classical',
  'contemporary classical': 'classical',
  'contemporary country': 'country',
  'contemporary folk': 'folk_americana',
  'contemporary gospel': 'inspirational',
  'contemporary jazz': 'jazz',
  'contemporary post-bop': 'jazz',
  'contemporary vocal jazz': 'jazz',
  'cook islands pop': 'roots',
  'cool jazz': 'jazz',
  'coptic hymn': 'inspirational',
  'coral gospel': 'inspirational',
  'cork indie': 'indie_alt',
  'cornetas y tambores': 'roots',
  'cornish folk': 'roots',
  'cornwall indie': 'indie_alt',
  'corridos cristianos': 'inspirational',
  'corridos tumbados': 'latin',
  'corsican folk': 'roots',
  'cosmic american': 'folk_americana',
  'cosmic black metal': 'metal',
  'cosmic post-rock': 'rock',
  'cosmic uplifting trance': 'edm_dance',
  'country blues': 'blues',
  'country boogie': 'country',
  'country dawn': 'country',
  'country gospel': 'country',
  'country pop': 'country',
  'country quebecois': 'country',
  'country rap': 'country',
  'country road': 'country',
  'country rock': 'rock',
  'coupe-decale': 'afro',
  'coventry indie': 'indie_alt',
  'cowboy western': 'country',
  'crack rock steady': 'punk',
  'croatian electronic': 'electronic',
  'croatian folk': 'roots',
  'croatian hip hop': 'hiphop',
  'croatian indie': 'pop',
  'croatian metal': 'metal',
  'croatian pop': 'pop',
  'croatian rock': 'rock',
  'crossover prog': 'rock',
  'crossover thrash': 'punk',
  'crust punk': 'punk',
  'cryptic black metal': 'metal',
  'cuatro venezolano': 'roots',
  'cuban alternative': 'latin',
  'cuban electronic': 'electronic',
  'cuban rumba': 'roots',
  'cueca chilena': 'roots',
  'cuento infantile': 'children',
  'cumbia andina mexicana': 'regionalmexican',
  'cumbia boliviana': 'latin',
  'cumbia chilena': 'latin',
  'cumbia colombiana regia': 'latin',
  'cumbia ecuatoriana': 'latin',
  'cumbia funk': 'latin',
  'cumbia lagunera': 'regionalmexican',
  'cumbia paraguaya': 'latin',
  'cumbia peruana': 'latin',
  'cumbia pop': 'latin',
  'cumbia ranchera': 'latin',
  'cumbia salvadorena': 'latin',
  'cumbia santafesina': 'latin',
  'cumbia sonidera': 'regionalmexican',
  'cumbia surena': 'latin',
  'cumbia uruguaya': 'latin',
  'cumbia villera': 'hiphop',
  'cyber metal': 'metal',
  'cypriot pop': 'pop',
  'czech classical piano': 'classical',
  'czech classical': 'classical',
  'czech contemporary classical': 'classical',
  'czech electronic': 'electronic',
  'czech folk': 'roots',
  'czech hip hop': 'hiphop',
  'czech indie': 'indie_alt',
  'czech metal': 'metal',
  'czech pop rock': 'rock',
  'czech pop': 'pop',
  'czech punk': 'punk',
  'czech rock': 'rock',
  'czsk black metal': 'metal',
  'czsk hip hop': 'hiphop',
  'czsk reggae': 'reggae',
  'd-beat': 'punk',
  'dainuojamoji poezija': 'pop',
  'dakke dak': 'edm_dance',
  'dalarna indie': 'pop',
  'dallas indie': 'indie_alt',
  'dance pop': 'pop',
  'dance rock': 'rock',
  'dance-punk': 'punk',
  'dancehall colombiano': 'latin',
  'dangdut koplo': 'pop',
  'dangdut remix': 'pop',
  'danish alternative rock': 'danish',
  'danish black metal': 'metal',
  'danish choir': 'roots',
  'danish classical': 'classical',
  'danish contemporary classical': 'classical',
  'danish death metal': 'metal',
  'danish electro-pop': 'danish',
  'danish electro': 'electronic',
  'danish electronic': 'electronic',
  'danish electropop': 'pop',
  'danish experimental': 'atmospheric',
  'danish folk': 'roots',
  'danish hardcore': 'punk',
  'danish hip hop': 'hiphop',
  'danish indie pop': 'indie_alt',
  'danish indie': 'indie_alt',
  'danish jazz': 'danish',
  'danish metal': 'metal',
  'danish modern jazz': 'jazz',
  'danish pop rock': 'danish',
  'danish pop': 'danish',
  'danish post-punk': 'rock',
  'danish punk': 'punk',
  'danish rock': 'rock',
  'danish singer-songwriter': 'pop',
  'danish techno': 'edm_dance',
  'dansk lovsang': 'inspirational',
  'dark ambient': 'atmospheric',
  'dark black metal': 'metal',
  'dark cabaret': 'punk',
  'dark clubbing': 'edm_dance',
  'dark disco': 'electronic',
  'dark electro-industrial': 'electronic',
  'dark electro': 'electronic',
  'dark folk': 'folk_americana',
  'dark hardcore': 'edm_dance',
  'dark jazz': 'jazz',
  'dark minimal techno': 'edm_dance',
  'dark post-punk': 'indie_alt',
  'dark progressive house': 'edm_dance',
  'dark psytrance': 'edm_dance',
  'dark techno': 'electronic',
  'dark trap': 'hiphop',
  'dark wave': 'edm_dance',
  'dayton indie': 'indie_alt',
  'dc hardcore': 'punk',
  'dc indie': 'indie_alt',
  'death doom': 'metal',
  'death industrial': 'atmospheric',
  'death metal': 'metal',
  'deconstructed club': 'electronic',
  'deep acoustic pop': 'pop',
  'deep active rock': 'rock',
  'deep adult standards': 'oldies',
  'deep ambient': 'atmospheric',
  'deep big room': 'edm_dance',
  'deep brazilian pop': 'brazilian',
  'deep breakcore': 'edm_dance',
  'deep ccm': 'inspirational',
  'deep chill-out': 'background',
  'deep chill': 'background',
  'deep christian rock': 'inspirational',
  'deep classic garage rock': 'oldies',
  'deep comedy': 'spoken',
  'deep contemporary country': 'country',
  'deep dance pop': 'pop',
  'deep darkpsy': 'edm_dance',
  'deep deep house': 'edm_dance',
  'deep deep tech house': 'edm_dance',
  'deep delta blues': 'blues',
  'deep disco house': 'edm_dance',
  'deep disco': 'soul',
  'deep discofox': 'pop',
  'deep dnb': 'electronic',
  'deep downtempo fusion': 'edm_dance',
  'deep dubstep': 'edm_dance',
  'deep dutch hip hop': 'dutch',
  'deep east coast hip hop': 'hiphop',
  'deep euro house': 'edm_dance',
  'deep eurodance': 'edm_dance',
  'deep filthstep': 'edm_dance',
  'deep flow': 'hiphop',
  'deep folk metal': 'metal',
  'deep free jazz': 'jazz',
  'deep freestyle': 'pop',
  'deep full on': 'edm_dance',
  'deep funk carioca': 'funkbrazil',
  'deep funk house': 'edm_dance',
  'deep funk ostentacao': 'brazilian',
  'deep funk': 'soul',
  'deep g funk': 'hiphop',
  'deep german hip hop': 'hiphop',
  'deep german indie': 'indie_alt',
  'deep german punk': 'punk',
  'deep gothic post-punk': 'indie_alt',
  'deep groove house': 'edm_dance',
  'deep happy hardcore': 'edm_dance',
  'deep hardcore punk': 'punk',
  'deep hardcore': 'edm_dance',
  'deep hardtechno': 'edm_dance',
  'deep house': 'edm_dance',
  'deep idm': 'electronic',
  'deep indian pop': 'desi',
  'deep indie pop': 'indie_alt',
  'deep indie rock': 'indie_alt',
  'deep indie singer-songwriter': 'folk_americana',
  'deep italo disco': 'edm_dance',
  'deep jazz fusion': 'jazz',
  'deep latin alternative': 'latin',
  'deep latin christian': 'inspirational',
  'deep latin jazz': 'latin',
  'deep liquid bass': 'edm_dance',
  'deep liquid': 'edm_dance',
  'deep melodic death metal': 'metal',
  'deep melodic hard rock': 'rock',
  'deep melodic metalcore': 'rock',
  'deep metalcore': 'metal',
  'deep minimal techno': 'edm_dance',
  'deep motown': 'oldies',
  'deep neo-synthpop': 'indie_alt',
  'deep neofolk': 'roots',
  'deep new americana': 'folk_americana',
  'deep new wave': 'indie_alt',
  'deep norteno': 'regionalmexican',
  'deep northern soul': 'soul',
  'deep orgcore': 'punk',
  'deep pop edm': 'edm_dance',
  'deep pop emo': 'indie_alt',
  'deep power-pop punk': 'punk',
  'deep progressive house': 'edm_dance',
  'deep progressive trance': 'edm_dance',
  'deep psychobilly': 'punk',
  'deep psytrance': 'edm_dance',
  'deep punk rock': 'punk',
  'deep r&b': 'rnb',
  'deep ragga': 'latin',
  'deep rai': 'roots',
  'deep regional mexican': 'regionalmexican',
  'deep smooth jazz': 'jazz',
  'deep smooth r&b': 'rnb',
  'deep soft rock': 'rock',
  'deep soul house': 'edm_dance',
  'deep soundtrack': 'soundtrack',
  'deep southern soul': 'soul',
  'deep southern trap': 'hiphop',
  'deep space rock': 'rock',
  'deep sunset lounge': 'edm_dance',
  'deep surf music': 'oldies',
  'deep swedish rock': 'rock',
  'deep symphonic black metal': 'metal',
  'deep talent show': 'pop',
  'deep tech house': 'edm_dance',
  'deep techno': 'edm_dance',
  'deep tropical house': 'edm_dance',
  'deep turkish pop': 'pop',
  'deep underground hip hop': 'hiphop',
  'deep uplifting trance': 'edm_dance',
  'deep vocal house': 'edm_dance',
  'deep vocal jazz': 'jazz',
  'delaware indie': 'indie_alt',
  'delta blues': 'blues',
  'denpa-kei': 'j_tracks',
  'denton tx indie': 'indie_alt',
  'denver indie': 'indie_alt',
  'denver metal': 'metal',
  'denver rap': 'hiphop',
  'depressive black metal': 'metal',
  'derby indie': 'indie_alt',
  'derry indie': 'indie_alt',
  'desert blues': 'roots',
  'desi hip hop': 'hiphop',
  'desi pop': 'desi',
  'destroy techno': 'edm_dance',
  'detroit hip hop': 'hiphop',
  'detroit house': 'edm_dance',
  'detroit indie': 'indie_alt',
  'detroit techno': 'edm_dance',
  'detroit trap': 'hiphop',
  'detske pesnicky': 'children',
  'detske pisnicky': 'children',
  'detski pesnichki': 'children',
  'detskie pesni': 'children',
  'deutsch disney': 'children',
  'devon indie': 'indie_alt',
  'dfw rap': 'hiphop',
  'digital hardcore': 'electronic',
  'dinner jazz': 'jazz',
  'dirty south rap': 'hiphop',
  'dirty texas rap': 'hiphop',
  'disco house': 'edm_dance',
  'disco polo': 'pop',
  'disney espanol': 'children',
  'disney italiano': 'children',
  'disney portugues brasil': 'brazilian',
  'disney portugues': 'children',
  'disney svenska': 'children',
  'diva house': 'edm_dance',
  'diy emo': 'indie_alt',
  'diy pop punk': 'punk',
  'dmv rap': 'hiphop',
  'dominican indie': 'indie_alt',
  'dominican pop': 'latin',
  'dong-yo': 'children',
  'doo-wop': 'oldies',
  'doom metal': 'metal',
  'dortmund indie': 'indie_alt',
  'double drumming': 'rock',
  'downtempo bass': 'edm_dance',
  'downtempo fusion': 'atmospheric',
  'dream pop': 'indie_alt',
  'dream trance': 'edm_dance',
  'dresden indie': 'indie_alt',
  'drill and bass': 'edm_dance',
  'drill espanol': 'hiphop',
  'drill francais': 'french_variety',
  'drill tuga': 'hiphop',
  'drone ambient': 'atmospheric',
  'drone folk': 'indie_alt',
  'drone metal': 'metal',
  'drone psych': 'indie_alt',
  'drone rock': 'rock',
  'drum and bass': 'edm_dance',
  'dub brasileiro': 'brazilian',
  'dub metal': 'metal',
  'dub poetry': 'reggae',
  'dub product': 'reggae',
  'dub reggae': 'reggae',
  'dub techno': 'edm_dance',
  'dublin indie': 'indie_alt',
  'dubstep product': 'edm_dance',
  'duluth indie': 'indie_alt',
  'dundee indie': 'indie_alt',
  'dunedin indie': 'indie_alt',
  'dunedin sound': 'indie_alt',
  'dungeon synth': 'metal',
  'dusseldorf electronic': 'electronic',
  'dusseldorf indie': 'indie_alt',
  'dutch americana': 'roots',
  'dutch black metal': 'metal',
  'dutch blues': 'blues',
  'dutch cabaret': 'comedy',
  'dutch classical piano': 'classical',
  'dutch contemporary classical': 'classical',
  'dutch death metal': 'metal',
  'dutch disney': 'children',
  'dutch dnb': 'edm_dance',
  'dutch drill': 'hiphop',
  'dutch edm': 'edm_dance',
  'dutch experimental electronic': 'electronic',
  'dutch experimental': 'atmospheric',
  'dutch folk': 'roots',
  'dutch hip hop': 'hiphop',
  'dutch house': 'edm_dance',
  'dutch idol pop': 'pop',
  'dutch indie rock': 'rock',
  'dutch indie': 'dutch',
  'dutch jazz': 'jazz',
  'dutch metal': 'metal',
  'dutch moombahton': 'pop',
  'dutch musical': 'pop',
  'dutch pop': 'dutch',
  'dutch prog': 'rock',
  'dutch punk rock': 'punk',
  'dutch punk': 'punk',
  'dutch r&b': 'rnb',
  'dutch rap pop': 'pop',
  'dutch rock': 'dutch',
  'dutch singer-songwriter': 'pop',
  'dutch tech house': 'edm_dance',
  'dutch trance': 'edm_dance',
  'dutch trap': 'hiphop',
  'dutch underground hip hop': 'hiphop',
  'early american folk': 'folk_americana',
  'early avant garde': 'atmospheric',
  'early french punk': 'french_variety',
  'early modern classical': 'classical',
  'early music choir': 'classical',
  'early music ensemble': 'classical',
  'early music': 'classical',
  'early reggae': 'reggae',
  'early romantic era': 'classical',
  'early synthpop': 'pop',
  'early us punk': 'punk',
  'east anglia indie': 'indie_alt',
  'east coast hip hop': 'hiphop',
  'east coast reggae': 'reggae',
  'eastern bloc groove': 'pop',
  'easy listening': 'oldies',
  'eau claire indie': 'indie_alt',
  'ecm-style jazz': 'jazz',
  'ecuadorian alternative rock': 'latin',
  'ecuadorian indie': 'indie_alt',
  'ecuadorian pop': 'latin',
  'edinburgh indie': 'indie_alt',
  'edinburgh metal': 'metal',
  'edmonton indie': 'indie_alt',
  'egyptian alternative': 'pop',
  'egyptian hip hop': 'hiphop',
  'egyptian pop': 'arabic',
  'egyptian traditional': 'roots',
  'el paso indie': 'indie_alt',
  'electric bass': 'jazz',
  'electric blues': 'blues',
  'electro bailando': 'latin',
  'electro dub': 'reggae',
  'electro house': 'edm_dance',
  'electro jazz': 'jazz',
  'electro latino': 'latin',
  'electro swing': 'pop',
  'electro trash': 'edm_dance',
  'electro-industrial': 'electronic',
  'electro-pop francais': 'french_variety',
  'electroacoustic composition': 'electronic',
  'electroacoustic improvisation': 'atmospheric',
  'electronic djent': 'metal',
  'electronic rock': 'rock',
  'electronic trap': 'edm_dance',
  'electronica argentina': 'latin',
  'electronica chilena': 'latin',
  'electronica cristiana': 'inspirational',
  'electronica venezuela': 'electronic',
  'eletronica underground brasileira': 'brazilian',
  'emo mexicano': 'rock',
  'emo punk': 'punk',
  'emo rap italiano': 'hiphop',
  'emo rap': 'hiphop',
  'english baroque': 'classical',
  'english indie rock': 'indie_alt',
  'english renaissance': 'classical',
  'epic black metal': 'metal',
  'epic doom': 'metal',
  'er ge': 'children',
  'eritrean pop': 'afro',
  'escape room': 'pop',
  'essex indie': 'indie_alt',
  'estonian electronic': 'electronic',
  'estonian folk': 'roots',
  'estonian hip hop': 'hiphop',
  'estonian indie': 'indie_alt',
  'estonian jazz': 'jazz',
  'estonian metal': 'metal',
  'estonian pop': 'pop',
  'estonian rock': 'rock',
  'ethereal gothic': 'indie_alt',
  'ethereal wave': 'atmospheric',
  'ethio-jazz': 'jazz',
  'ethiopian pop': 'afro',
  'eugene indie': 'indie_alt',
  'euphoric hardstyle': 'edm_dance',
  'euro hi-nrg': 'edm_dance',
  'euskal indie': 'indie_alt',
  'euskal metal': 'metal',
  'euskal musica': 'pop',
  'euskal rock': 'rock',
  'experimental ambient': 'atmospheric',
  'experimental bass': 'electronic',
  'experimental big band': 'jazz',
  'experimental black metal': 'metal',
  'experimental club': 'edm_dance',
  'experimental dub': 'reggae',
  'experimental dubstep': 'edm_dance',
  'experimental electronic': 'electronic',
  'experimental folk': 'folk_americana',
  'experimental guitar': 'atmospheric',
  'experimental hip hop': 'hiphop',
  'experimental house': 'electronic',
  'experimental indie rock': 'indie_alt',
  'experimental indie': 'indie_alt',
  'experimental jazz': 'jazz',
  'experimental percussion': 'atmospheric',
  'experimental poetry': 'spoken',
  'experimental pop': 'pop',
  'experimental psych': 'atmospheric',
  'experimental rock': 'rock',
  'experimental synth': 'electronic',
  'experimental techno': 'electronic',
  'experimental vocal': 'atmospheric',
  'fallen angel': 'metal',
  'family gospel': 'inspirational',
  'fan chant': 'background',
  'faroese folk': 'roots',
  'faroese indie': 'pop',
  'faroese jazz': 'jazz',
  'faroese pop': 'pop',
  'faroese rock': 'rock',
  'fast melodic punk': 'punk',
  'fidget house': 'edm_dance',
  'field recording': 'atmospheric',
  'fife and drum': 'roots',
  'fijian pop': 'pop',
  'filter house': 'edm_dance',
  'final fantasy': 'j_tracks',
  'finlandssvenska musik': 'pop',
  'finnish alternative rock': 'rock',
  'finnish black metal': 'metal',
  'finnish blues': 'blues',
  'finnish choir': 'roots',
  'finnish classical': 'classical',
  'finnish contemporary classical': 'classical',
  'finnish dance pop': 'pop',
  'finnish death metal': 'metal',
  'finnish doom metal': 'metal',
  'finnish edm': 'edm_dance',
  'finnish electro': 'electronic',
  'finnish electronic': 'electronic',
  'finnish experimental': 'atmospheric',
  'finnish folk': 'roots',
  'finnish hard rock': 'rock',
  'finnish hardcore': 'punk',
  'finnish heavy metal': 'metal',
  'finnish hip hop': 'hiphop',
  'finnish idol pop': 'pop',
  'finnish indie': 'indie_alt',
  'finnish jazz': 'jazz',
  'finnish metal': 'metal',
  'finnish modern jazz': 'jazz',
  'finnish new wave': 'pop',
  'finnish pop': 'pop',
  'finnish post-punk': 'rock',
  'finnish power metal': 'metal',
  'finnish progressive rock': 'rock',
  'finnish psychedelic rock': 'rock',
  'finnish punk': 'punk',
  'finnish reggae': 'reggae',
  'finnish rockabilly': 'rock',
  'finnish soul': 'soul',
  'finnish tango': 'pop',
  'finnish techno': 'edm_dance',
  'finnish trap': 'hiphop',
  'finnish worship': 'inspirational',
  'firenze indie': 'pop',
  'flamenco fusion': 'pop',
  'flamenco guitar': 'roots',
  'flamenco urbano': 'latin',
  'flemish folk': 'roots',
  'flick hop': 'hiphop',
  'flint hip hop': 'hiphop',
  'float house': 'edm_dance',
  'florida death metal': 'metal',
  'florida hardcore': 'punk',
  'florida rap': 'hiphop',
  'fo jing': 'roots',
  'focus beats': 'background',
  'focus trance': 'edm_dance',
  'folclor afrocolombiano': 'roots',
  'folclor colombiano': 'roots',
  'folclore castilla y leon': 'roots',
  'folclore extremeno': 'roots',
  'folclore jujeno': 'roots',
  'folclore navarra': 'roots',
  'folclore portugues': 'roots',
  'folclore salteno': 'roots',
  'folclore santiagueno': 'roots',
  'folclore tucumano': 'roots',
  'folk black metal': 'metal',
  'folk brasileiro': 'brazilian',
  'folk cantabria': 'roots',
  'folk metal latinoamericano': 'metal',
  'folk metal': 'metal',
  'folk punk': 'punk',
  'folk rock italiano': 'rock',
  'folk rock': 'rock',
  'folk siciliana': 'roots',
  'folk-pop': 'indie_alt',
  'folklore argentino': 'roots',
  'folklore boliviano': 'roots',
  'folklore chileno': 'roots',
  'folklore ecuatoriano': 'roots',
  'folklore nuevo argentino': 'roots',
  'folklore panameno': 'roots',
  'folklore paraguayo': 'roots',
  'folklore peruano': 'roots',
  'folklore quebecois': 'roots',
  'folklore uruguayo': 'roots',
  'folklore venezolano': 'roots',
  'folklore veracruzano': 'roots',
  'forest psy': 'edm_dance',
  'forro de favela': 'brazilian',
  'forro gospel': 'inspirational',
  'forro instrumental': 'brazilian',
  'forro manauara': 'brazilian',
  'forro tradicional': 'brazilian',
  'fort wayne indie': 'indie_alt',
  'fort worth indie': 'indie_alt',
  'fourth world': 'atmospheric',
  'franco-flemish school': 'classical',
  'frankfurt electronic': 'electronic',
  'frankfurt indie': 'indie_alt',
  'freak folk': 'indie_alt',
  'free folk': 'atmospheric',
  'free improvisation': 'jazz',
  'free jazz': 'jazz',
  'fremantle indie': 'indie_alt',
  'french baroque': 'classical',
  'french black metal': 'french_variety',
  'french classical piano': 'classical',
  'french contemporary classical': 'classical',
  'french death metal': 'french_variety',
  'french dnb': 'french_variety',
  'french dub': 'french_variety',
  'french experimental rock': 'french_variety',
  'french folk pop': 'french_variety',
  'french folk': 'french_variety',
  'french garage rock': 'french_variety',
  'french hardcore': 'french_variety',
  'french hip hop': 'french_variety',
  'french indie folk': 'french_variety',
  'french indie pop': 'french_variety',
  'french indietronica': 'french_variety',
  'french jazz': 'french_variety',
  'french metal': 'french_variety',
  'french movie tunes': 'french_variety',
  'french oi': 'french_variety',
  'french opera': 'classical',
  'french orchestra': 'classical',
  'french pop': 'french_variety',
  'french post-punk': 'french_variety',
  'french post-rock': 'rock',
  'french psychedelic': 'french_variety',
  'french punk': 'french_variety',
  'french reggae': 'french_variety',
  'french renaissance': 'classical',
  'french rock': 'french_variety',
  'french romanticism': 'classical',
  'french shoegaze': 'french_variety',
  'french soundtrack': 'french_variety',
  'french stoner rock': 'french_variety',
  'french synthpop': 'french_variety',
  'french tech house': 'french_variety',
  'french techno': 'french_variety',
  'french worship': 'inspirational',
  'full on': 'edm_dance',
  'funeral doom': 'metal',
  'funk 150 bpm': 'brazilian',
  'funk bh': 'brazilian',
  'funk carioca': 'funkbrazil',
  'funk consciente': 'brazilian',
  'funk das antigas': 'brazilian',
  'funk evangelico': 'inspirational',
  'funk melody': 'brazilian',
  'funk metal': 'rock',
  'funk mexicano': 'soul',
  'funk ostentacao': 'brazilian',
  'funk paulista': 'brazilian',
  'funk pop': 'brazilian',
  'funk rock': 'rock',
  'funky breaks': 'edm_dance',
  'funky tech house': 'edm_dance',
  'future ambient': 'atmospheric',
  'future bass': 'edm_dance',
  'future funk': 'edm_dance',
  'future garage': 'edm_dance',
  'future house': 'edm_dance',
  'future rock': 'rock',
  'g funk': 'hiphop',
  'gabonese pop': 'afro',
  'gaian doom': 'metal',
  'gainesville indie': 'indie_alt',
  'gaita zuliana': 'latin',
  'galante era': 'classical',
  'galician folk': 'roots',
  'galician indie': 'pop',
  'galician jazz': 'jazz',
  'galician rock': 'rock',
  'galway indie': 'indie_alt',
  'gambian pop': 'afro',
  'gaming dubstep': 'edm_dance',
  'gaming edm': 'edm_dance',
  'gangster rap': 'hiphop',
  'garage house': 'edm_dance',
  'garage pop': 'indie_alt',
  'garage psych': 'indie_alt',
  'garage punk blues': 'indie_alt',
  'garage punk': 'punk',
  'garage rock mexicano': 'rock',
  'garage rock revival': 'rock',
  'garage rock': 'rock',
  'garifuna folk': 'roots',
  'gauze pop': 'indie_alt',
  'gay chorus': 'roots',
  'geek folk': 'comedy',
  'geek rock': 'comedy',
  'georgian alternative': 'pop',
  'georgian electronic': 'electronic',
  'georgian folk': 'roots',
  'georgian polyphony': 'roots',
  'georgian pop': 'roots',
  'german alternative rap': 'hiphop',
  'german alternative rock': 'rock',
  'german baroque': 'classical',
  'german black metal': 'metal',
  'german blues': 'blues',
  'german ccm': 'inspirational',
  'german choir': 'classical',
  'german classical piano': 'classical',
  'german cloud rap': 'hiphop',
  'german contemporary classical': 'classical',
  'german country': 'country',
  'german dance': 'edm_dance',
  'german dark minimal techno': 'edm_dance',
  'german death metal': 'metal',
  'german dnb': 'edm_dance',
  'german drill': 'hiphop',
  'german electronica': 'electronic',
  'german grindcore': 'metal',
  'german hard rock': 'rock',
  'german hardcore': 'punk',
  'german heavy metal': 'metal',
  'german hip hop': 'hiphop',
  'german house': 'edm_dance',
  'german indie folk': 'pop',
  'german indie pop': 'pop',
  'german indie rock': 'rock',
  'german indie': 'pop',
  'german jazz': 'jazz',
  'german literature': 'spoken',
  'german metal': 'metal',
  'german metalcore': 'rock',
  'german oi': 'punk',
  'german opera': 'classical',
  'german orchestra': 'classical',
  'german pagan metal': 'metal',
  'german pop rock': 'pop',
  'german pop': 'pop',
  'german post-hardcore': 'rock',
  'german post-punk': 'rock',
  'german post-rock': 'rock',
  'german power metal': 'metal',
  'german punk rock': 'punk',
  'german punk': 'punk',
  'german r&b': 'pop',
  'german reggae': 'reggae',
  'german renaissance': 'classical',
  'german rock': 'rock',
  'german rockabilly': 'rock',
  'german romanticism': 'classical',
  'german shoegaze': 'rock',
  'german show tunes': 'soundtrack',
  'german singer-songwriter': 'pop',
  'german ska': 'rock',
  'german soundtrack': 'soundtrack',
  'german stoner rock': 'rock',
  'german street punk': 'punk',
  'german tech house': 'edm_dance',
  'german techno': 'edm_dance',
  'german thrash metal': 'metal',
  'german trance': 'edm_dance',
  'german trap': 'hiphop',
  'german underground rap': 'hiphop',
  'german worship': 'inspirational',
  'ghanaian alternative': 'afro',
  'ghanaian gospel': 'inspirational',
  'ghanaian hip hop': 'hiphop',
  'ghanaian pop': 'afro',
  'ghanaian traditional': 'roots',
  'ghent indie': 'indie_alt',
  'girl group': 'pop',
  'glam metal': 'metal',
  'glam punk': 'punk',
  'glam rock': 'rock',
  'glasgow indie': 'indie_alt',
  'glee club': 'pop',
  'glitch beats': 'edm_dance',
  'glitch hop': 'edm_dance',
  'glitch pop': 'electronic',
  'glitter trance': 'edm_dance',
  'go-go': 'oldies',
  'goa psytrance': 'edm_dance',
  'goa trance': 'edm_dance',
  'gospel antigas': 'inspirational',
  'gospel blues': 'inspirational',
  'gospel drill': 'inspirational',
  'gospel italiano': 'inspirational',
  'gospel r&b': 'inspirational',
  'gospel rap': 'inspirational',
  'gospel reggae': 'inspirational',
  'gospel singers': 'inspirational',
  'gospel soul': 'soul',
  'gothenburg hip hop': 'hiphop',
  'gothenburg indie': 'indie_alt',
  'gothenburg metal': 'metal',
  'gothic alternative': 'indie_alt',
  'gothic americana': 'folk_americana',
  'gothic black metal': 'metal',
  'gothic doom': 'metal',
  'gothic metal': 'metal',
  'gothic post-punk': 'indie_alt',
  'gothic rock': 'rock',
  'gothic symphonic metal': 'metal',
  'gotico brasileiro': 'brazilian',
  'gotlandsk musik': 'pop',
  'granada indie': 'indie_alt',
  'grand rapids indie': 'indie_alt',
  'grave wave': 'indie_alt',
  'graz indie': 'indie_alt',
  'greek black metal': 'metal',
  'greek clarinet': 'roots',
  'greek contemporary classical': 'classical',
  'greek downtempo': 'electronic',
  'greek folk': 'roots',
  'greek guitar': 'roots',
  'greek hip hop': 'hiphop',
  'greek house': 'edm_dance',
  'greek indie rock': 'pop',
  'greek indie': 'indie_alt',
  'greek jazz': 'jazz',
  'greek metal': 'metal',
  'greek pop': 'pop',
  'greek psychedelic rock': 'rock',
  'greek punk': 'punk',
  'greek rock': 'rock',
  'greek swing': 'pop',
  'greek techno': 'edm_dance',
  'greek trap': 'hiphop',
  'greek underground rap': 'hiphop',
  'greenlandic pop': 'pop',
  'gregorian chant': 'roots',
  'grim death metal': 'metal',
  'grime brasileiro': 'brazilian',
  'grisly death metal': 'metal',
  'groove gospel': 'inspirational',
  'groove metal': 'rock',
  'groove room': 'edm_dance',
  'grunge argentina': 'rock',
  'grunge brasileiro': 'brazilian',
  'grunge pop': 'rock',
  'grunge revival': 'rock',
  'gruperas inmortales': 'regionalmexican',
  'guadalajara indie': 'indie_alt',
  'guam indie': 'indie_alt',
  'guatemalan indie': 'indie_alt',
  'guatemalan metal': 'metal',
  'guatemalan pop': 'latin',
  'guided meditation': 'spoken',
  'guinean pop': 'afro',
  'guitar case': 'pop',
  'guitarra argentina': 'latin',
  'guitarra clasica': 'classical',
  'guitarra portuguesa': 'roots',
  'gujarati garba': 'desi',
  'gujarati pop': 'desi',
  'gulf hip hop': 'hiphop',
  'gypsy fusion': 'rock',
  'gypsy jazz': 'jazz',
  'gypsy punk': 'punk',
  'haitian dance': 'latin',
  'haitian gospel': 'inspirational',
  'haitian traditional': 'roots',
  'halftime dnb': 'edm_dance',
  'halifax indie': 'indie_alt',
  'hamburg electronic': 'edm_dance',
  'hamburg hip hop': 'hiphop',
  'hamburg indie': 'indie_alt',
  'hamburger schule': 'rock',
  'hamilton on indie': 'indie_alt',
  'hammered dulcimer': 'roots',
  'hampton roads indie': 'indie_alt',
  'hands up': 'edm_dance',
  'happy hardcore': 'edm_dance',
  'hard alternative': 'rock',
  'hard bass': 'edm_dance',
  'hard bop': 'jazz',
  'hard chime': 'rock',
  'hard dance': 'edm_dance',
  'hard glam': 'rock',
  'hard house': 'edm_dance',
  'hard minimal techno': 'edm_dance',
  'hard motivation': 'spoken',
  'hard rock brasileiro': 'brazilian',
  'hard rock mexicano': 'rock',
  'hard rock': 'rock',
  'hard stoner rock': 'rock',
  'hard techno': 'edm_dance',
  'hard trance': 'edm_dance',
  'hardcore breaks': 'edm_dance',
  'hardcore hip hop': 'hiphop',
  'hardcore punk espanol': 'punk',
  'hardcore punk': 'punk',
  'hardcore techno': 'edm_dance',
  'harlem hip hop': 'hiphop',
  'harlem renaissance': 'jazz',
  'harmonica blues': 'blues',
  'harmonica jazz': 'jazz',
  'haryanvi pop': 'desi',
  'haur kantak': 'children',
  'hawaiian hip hop': 'hiphop',
  'hawaiian indie': 'indie_alt',
  'hawaiian punk': 'punk',
  'heartland rock': 'rock',
  'heavy alternative': 'rock',
  'heavy gothic rock': 'metal',
  'heavy psych': 'rock',
  'hi-nrg': 'pop',
  'hi-tech': 'edm_dance',
  'himalayan folk': 'roots',
  'himene tarava': 'roots',
  'hindi hip hop': 'hiphop',
  'hindi indie': 'desi',
  'hindi worship': 'inspirational',
  'hindustani classical': 'classical',
  'hindustani instrumental': 'roots',
  'hindustani vocal': 'roots',
  'hinos ccb': 'inspirational',
  'hip hop boliviano': 'hiphop',
  'hip hop cubano': 'hiphop',
  'hip hop galsen': 'hiphop',
  'hip hop quebecois': 'francophone',
  'hip hop tuga': 'hiphop',
  'hip hop': 'hiphop',
  'hip house': 'edm_dance',
  'hip pop': 'rnb',
  'histoire pour enfants': 'french_variety',
  'historic classical performance': 'classical',
  'historic orchestral performance': 'classical',
  'historic piano performance': 'classical',
  'historic string quartet': 'classical',
  'historical keyboard': 'classical',
  'historically informed performance': 'classical',
  'hmong pop': 'pop',
  'hokkien pop': 'pop',
  'hong kong hip hop': 'hiphop',
  'hong kong indie': 'pop',
  'hong kong rock': 'rock',
  'honky tonk': 'country',
  'honky-tonk piano': 'oldies',
  'horror punk brasileiro': 'brazilian',
  'horror punk': 'punk',
  'horror synth': 'atmospheric',
  'house argentino': 'latin',
  'houston indie': 'indie_alt',
  'houston rap': 'hiphop',
  'huayno popular': 'latin',
  'hull indie': 'indie_alt',
  'hungarian black metal': 'metal',
  'hungarian choir': 'roots',
  'hungarian classical performance': 'classical',
  'hungarian classical piano': 'classical',
  'hungarian contemporary classical': 'classical',
  'hungarian edm': 'edm_dance',
  'hungarian folk': 'roots',
  'hungarian hip hop': 'hiphop',
  'hungarian indie': 'indie_alt',
  'hungarian metal': 'metal',
  'hungarian pop': 'pop',
  'hungarian punk': 'punk',
  'hungarian rock': 'rock',
  'hungarian techno': 'edm_dance',
  'hungarian underground rap': 'hiphop',
  'hurdy-gurdy': 'roots',
  'icelandic black metal': 'metal',
  'icelandic choir': 'roots',
  'icelandic classical': 'classical',
  'icelandic electronic': 'pop',
  'icelandic experimental': 'pop',
  'icelandic folk': 'pop',
  'icelandic hip hop': 'hiphop',
  'icelandic indie': 'indie_alt',
  'icelandic jazz': 'jazz',
  'icelandic metal': 'metal',
  'icelandic pop': 'pop',
  'icelandic rock': 'rock',
  'icelandic traditional': 'roots',
  'idaho indie': 'indie_alt',
  'idol rock': 'j_tracks',
  'igbo traditional': 'pop',
  'igbo worship': 'inspirational',
  'ilocano pop': 'pop',
  'indian ambient': 'desi',
  'indian classical': 'classical',
  'indian edm': 'edm_dance',
  'indian electronic': 'desi',
  'indian folk': 'roots',
  'indian fusion': 'desi',
  'indian indie': 'indie_alt',
  'indian instrumental rock': 'rock',
  'indian instrumental': 'roots',
  'indian jazz': 'jazz',
  'indian lo-fi': 'desi',
  'indian metal': 'metal',
  'indian rock': 'rock',
  'indian singer-songwriter': 'desi',
  'indian techno': 'edm_dance',
  'indian violin': 'roots',
  'indiana hip hop': 'hiphop',
  'indiana indie': 'indie_alt',
  'indie anthem-folk': 'indie_alt',
  'indie arequipeno': 'latin',
  'indie boliviano': 'pop',
  'indie cafe pop': 'indie_alt',
  'indie campechano': 'pop',
  'indie canario': 'pop',
  'indie cantabria': 'indie_alt',
  'indie catala': 'indie_alt',
  'indie catracho': 'pop',
  'indie cordoba': 'indie_alt',
  'indie cristao': 'inspirational',
  'indie curitibano': 'brazilian',
  'indie deutschrap': 'hiphop',
  'indie dream pop': 'indie_alt',
  'indie electronica': 'electronic',
  'indie electropop': 'indie_alt',
  'indie emo rock': 'indie_alt',
  'indie emo': 'punk',
  'indie extremena': 'indie_alt',
  'indie folk argentino': 'latin',
  'indie folk italiano': 'pop',
  'indie folk': 'indie_alt',
  'indie fuzzpop': 'indie_alt',
  'indie game soundtrack': 'soundtrack',
  'indie garage rock': 'indie_alt',
  'indie hidalguense': 'pop',
  'indie hidrocalido': 'pop',
  'indie hip hop': 'hiphop',
  'indie jazz': 'jazz',
  'indie liguria': 'indie_alt',
  'indie michoacano': 'pop',
  'indie napoletano': 'indie_alt',
  'indie nica': 'pop',
  'indie nordeste argentino': 'latin',
  'indie paraense': 'brazilian',
  'indie platense': 'indie_alt',
  'indie poblano': 'pop',
  'indie pop rap': 'hiphop',
  'indie pop rock': 'indie_alt',
  'indie pop': 'indie_alt',
  'indie poptimism': 'pop',
  'indie psych-pop': 'indie_alt',
  'indie psychedelic rock': 'rock',
  'indie punk': 'punk',
  'indie quebecois': 'indie_alt',
  'indie queretano': 'pop',
  'indie r&b': 'pop',
  'indie rock colombiano': 'latin',
  'indie rock italiano': 'indie_alt',
  'indie rock mexicano': 'rock',
  'indie rock peruano': 'latin',
  'indie rock': 'indie_alt',
  'indie rockism': 'indie_alt',
  'indie salvadoreno': 'indie_alt',
  'indie shoegaze': 'indie_alt',
  'indie siciliano': 'indie_alt',
  'indie singer-songwriter': 'folk_americana',
  'indie soul': 'indie_alt',
  'indie sudcaliforniano': 'pop',
  'indie surf': 'indie_alt',
  'indie tabasqueno': 'pop',
  'indie tico': 'indie_alt',
  'indie triste': 'latin',
  'indie trujillano': 'latin',
  'indie tucumano': 'latin',
  'indie valenciana': 'pop',
  'indie veneto': 'pop',
  'indie viet': 'indie_alt',
  'indonesian alternative rock': 'rock',
  'indonesian bamboo': 'roots',
  'indonesian black metal': 'metal',
  'indonesian city pop': 'pop',
  'indonesian death metal': 'metal',
  'indonesian deathcore': 'metal',
  'indonesian edm': 'edm_dance',
  'indonesian electronic': 'electronic',
  'indonesian emo': 'rock',
  'indonesian experimental': 'rock',
  'indonesian folk': 'pop',
  'indonesian hardcore': 'punk',
  'indonesian hip hop': 'hiphop',
  'indonesian idol pop': 'pop',
  'indonesian indie pop': 'pop',
  'indonesian indie rock': 'rock',
  'indonesian indie': 'pop',
  'indonesian jazz': 'jazz',
  'indonesian metal': 'metal',
  'indonesian pop punk': 'punk',
  'indonesian pop': 'musik_indonesia',
  'indonesian post-hardcore': 'rock',
  'indonesian psychedelia': 'pop',
  'indonesian punk': 'punk',
  'indonesian r&b': 'pop',
  'indonesian reggae': 'reggae',
  'indonesian rock': 'rock',
  'indonesian shoegaze': 'rock',
  'indonesian ska': 'reggae',
  'indonesian worship': 'inspirational',
  'industrial black metal': 'metal',
  'industrial hardcore': 'edm_dance',
  'industrial hip hop': 'hiphop',
  'industrial metal': 'metal',
  'industrial noise': 'atmospheric',
  'industrial rock': 'rock',
  'industrial techno': 'edm_dance',
  'indy indie': 'indie_alt',
  'instrumental acoustic guitar': 'background',
  'instrumental black metal': 'metal',
  'instrumental bluegrass': 'folk_americana',
  'instrumental death metal': 'metal',
  'instrumental funk': 'soul',
  'instrumental grime': 'hiphop',
  'instrumental math rock': 'rock',
  'instrumental post-rock': 'rock',
  'instrumental progressive metal': 'metal',
  'instrumental rock': 'rock',
  'instrumental soul': 'soul',
  'instrumental stoner rock': 'rock',
  'instrumental surf': 'rock',
  'intelligent dance music': 'edm_dance',
  'inuit pop': 'pop',
  'inuit traditional': 'roots',
  'iowa hip hop': 'hiphop',
  'iowa indie': 'indie_alt',
  'iranian experimental': 'atmospheric',
  'irish accordion': 'roots',
  'irish ballad': 'roots',
  'irish banjo': 'roots',
  'irish classical': 'classical',
  'irish contemporary classical': 'classical',
  'irish country': 'roots',
  'irish dance': 'roots',
  'irish drill': 'hiphop',
  'irish electronic': 'electronic',
  'irish experimental electronic': 'electronic',
  'irish experimental': 'atmospheric',
  'irish fiddle': 'folk_americana',
  'irish flute': 'roots',
  'irish folk': 'roots',
  'irish gaelic folk': 'roots',
  'irish hip hop': 'hiphop',
  'irish indie rock': 'indie_alt',
  'irish indie': 'indie_alt',
  'irish metal': 'metal',
  'irish modern jazz': 'jazz',
  'irish neo-traditional': 'roots',
  'irish pop': 'pop',
  'irish pub song': 'roots',
  'irish rebel song': 'roots',
  'irish rock': 'rock',
  'irish singer-songwriter': 'folk_americana',
  'irish techno': 'edm_dance',
  'irish trap': 'hiphop',
  'irish underground rap': 'hiphop',
  'islamic recitation': 'roots',
  'isle of man indie': 'indie_alt',
  'isle of wight indie': 'indie_alt',
  'israeli classical piano': 'classical',
  'israeli classical': 'classical',
  'israeli folk': 'roots',
  'israeli hip hop': 'hiphop',
  'israeli indie': 'indie_alt',
  'israeli jazz': 'jazz',
  'israeli mediterranean': 'pop',
  'israeli metal': 'metal',
  'israeli pop': 'pop',
  'israeli punk': 'punk',
  'israeli rock': 'rock',
  'israeli singer-songwriter': 'pop',
  'israeli techno': 'edm_dance',
  'israeli trap': 'hiphop',
  'italian adult pop': 'pop',
  'italian alternative': 'pop',
  'italian baritone': 'roots',
  'italian baroque ensemble': 'classical',
  'italian baroque': 'classical',
  'italian bass': 'roots',
  'italian black metal': 'metal',
  'italian blues': 'blues',
  'italian choir': 'classical',
  'italian classical guitar': 'classical',
  'italian classical piano': 'classical',
  'italian contemporary classical': 'classical',
  'italian contemporary jazz': 'jazz',
  'italian death metal': 'metal',
  'italian disco': 'pop',
  'italian doom metal': 'metal',
  'italian electronica': 'electronic',
  'italian emo': 'rock',
  'italian experimental': 'atmospheric',
  'italian folk metal': 'metal',
  'italian folk': 'roots',
  'italian gothic metal': 'metal',
  'italian gothic': 'rock',
  'italian hardcore': 'punk',
  'italian heavy metal': 'metal',
  'italian hip hop': 'hiphop',
  'italian indie pop': 'indie_alt',
  'italian industrial': 'rock',
  'italian jazz fusion': 'jazz',
  'italian jazz': 'jazz',
  'italian library music': 'atmospheric',
  'italian lounge': 'jazz',
  'italian mandolin': 'roots',
  'italian metal': 'metal',
  'italian metalcore': 'rock',
  'italian mezzo-soprano': 'roots',
  'italian modern prog': 'rock',
  'italian new wave': 'pop',
  'italian occult psychedelia': 'atmospheric',
  'italian opera': 'classical',
  'italian orchestra': 'classical',
  'italian pop punk': 'punk',
  'italian pop rock': 'pop',
  'italian pop': 'pop',
  'italian post punk': 'rock',
  'italian post-hardcore': 'punk',
  'italian post-rock': 'rock',
  'italian power metal': 'metal',
  'italian progressive metal': 'metal',
  'italian progressive rock': 'rock',
  'italian punk': 'punk',
  'italian reggae': 'reggae',
  'italian renaissance': 'classical',
  'italian rockabilly': 'rock',
  'italian romanticism': 'classical',
  'italian ska': 'reggae',
  'italian soprano': 'roots',
  'italian soundtrack': 'soundtrack',
  'italian stoner rock': 'rock',
  'italian tech house': 'edm_dance',
  'italian techno': 'edm_dance',
  'italian tenor': 'roots',
  'italian trance': 'edm_dance',
  'italian underground hip hop': 'hiphop',
  'italian violin': 'classical',
  'italo beats': 'edm_dance',
  'italo dance': 'edm_dance',
  'italo house': 'electronic',
  'j-acoustic': 'j_tracks',
  'j-ambient': 'j_tracks',
  'j-core': 'edm_dance',
  'j-dance': 'edm_dance',
  'j-division': 'j_tracks',
  'j-idol': 'j_tracks',
  'j-indie': 'j_tracks',
  'j-metal': 'j_tracks',
  'j-pixie': 'indie_alt',
  'j-pop boy group': 'j_tracks',
  'j-pop girl group': 'j_tracks',
  'j-pop': 'j_tracks',
  'j-poprock': 'j_tracks',
  'j-punk': 'j_tracks',
  'j-rap': 'j_tracks',
  'j-reggae': 'j_tracks',
  'j-rock': 'j_tracks',
  'jacksonville indie': 'indie_alt',
  'jam band': 'rock',
  'jangle pop': 'indie_alt',
  'jangle rock': 'indie_alt',
  'japanese alternative rock': 'j_tracks',
  'japanese black metal': 'j_tracks',
  'japanese blues': 'j_tracks',
  'japanese celtic': 'j_tracks',
  'japanese chillhop': 'electronic',
  'japanese choir': 'j_tracks',
  'japanese city pop': 'j_tracks',
  'japanese classical performance': 'classical',
  'japanese classical piano': 'classical',
  'japanese classical': 'classical',
  'japanese concert band': 'j_tracks',
  'japanese death metal': 'j_tracks',
  'japanese disney': 'j_tracks',
  'japanese dream pop': 'j_tracks',
  'japanese electronic': 'electronic',
  'japanese electropop': 'j_tracks',
  'japanese emo': 'j_tracks',
  'japanese experimental': 'j_tracks',
  'japanese folk': 'j_tracks',
  'japanese garage rock': 'j_tracks',
  'japanese girl punk': 'j_tracks',
  'japanese guitar': 'j_tracks',
  'japanese hardcore': 'j_tracks',
  'japanese heavy metal': 'j_tracks',
  'japanese idm': 'j_tracks',
  'japanese indie folk': 'j_tracks',
  'japanese indie pop': 'jazz',
  'japanese indie rock': 'j_tracks',
  'japanese instrumental': 'j_tracks',
  'japanese jazz fusion': 'j_tracks',
  'japanese jazz': 'jazz',
  'japanese jazztronica': 'j_tracks',
  'japanese math rock': 'j_tracks',
  'japanese melodic punk': 'j_tracks',
  'japanese metalcore': 'j_tracks',
  'japanese new wave': 'j_tracks',
  'japanese piano': 'j_tracks',
  'japanese pop punk': 'j_tracks',
  'japanese post-hardcore': 'j_tracks',
  'japanese post-punk': 'j_tracks',
  'japanese post-rock': 'j_tracks',
  'japanese power metal': 'j_tracks',
  'japanese prog': 'j_tracks',
  'japanese progressive house': 'edm_dance',
  'japanese psychedelic rock': 'j_tracks',
  'japanese psychedelic': 'rock',
  'japanese punk rock': 'j_tracks',
  'japanese r&b': 'j_tracks',
  'japanese rockabilly': 'j_tracks',
  'japanese shoegaze': 'indie_alt',
  'japanese singer-songwriter': 'j_tracks',
  'japanese ska': 'j_tracks',
  'japanese soul': 'j_tracks',
  'japanese soundtrack': 'soundtrack',
  'japanese techno': 'edm_dance',
  'japanese traditional': 'j_tracks',
  'japanese trap': 'j_tracks',
  'japanese vgm': 'j_tracks',
  'japanese vocal jazz': 'j_tracks',
  'japanese worship': 'inspirational',
  'javanese dangdut': 'pop',
  'jaw harp': 'roots',
  'jazz accordion': 'jazz',
  'jazz blues': 'blues',
  'jazz boom bap': 'hiphop',
  'jazz brass': 'jazz',
  'jazz caraibes': 'jazz',
  'jazz catala': 'jazz',
  'jazz chileno': 'jazz',
  'jazz clarinet': 'jazz',
  'jazz colombiano': 'latin',
  'jazz composition': 'jazz',
  'jazz cubano': 'latin',
  'jazz double bass': 'jazz',
  'jazz drums': 'jazz',
  'jazz flute': 'jazz',
  'jazz funk': 'jazz',
  'jazz fusion': 'jazz',
  'jazz guitar': 'jazz',
  'jazz harp': 'jazz',
  'jazz metal': 'metal',
  'jazz mexicano': 'latin',
  'jazz orchestra': 'jazz',
  'jazz organ': 'jazz',
  'jazz piano': 'jazz',
  'jazz pop': 'pop',
  'jazz quartet': 'jazz',
  'jazz rap': 'hiphop',
  'jazz rock': 'rock',
  'jazz saxophone': 'jazz',
  'jazz tico': 'jazz',
  'jazz trio': 'jazz',
  'jazz trombone': 'jazz',
  'jazz trumpet': 'jazz',
  'jazz tuba': 'jazz',
  'jazz venezolano': 'latin',
  'jazz vibraphone': 'jazz',
  'jazz violin': 'jazz',
  'jersey club': 'edm_dance',
  'jewish a capella': 'pop',
  'jewish cantorial': 'roots',
  'jewish hip hop': 'hiphop',
  'jewish pop': 'pop',
  'jig and reel': 'roots',
  'jordanian pop': 'pop',
  'jota aragonesa': 'roots',
  'jovem guarda': 'brazilian',
  'jug band': 'folk_americana',
  'jump blues': 'blues',
  'jump up': 'edm_dance',
  'junior eurovision': 'pop',
  'k-hop': 'kpop',
  'k-indie': 'indie_alt',
  'k-pop boy group': 'pop',
  'k-pop girl group': 'pop',
  'k-pop': 'kpop',
  'k-rap': 'hiphop',
  'k-rock': 'rock',
  'kaba gaida': 'roots',
  'kannada bhava geethe': 'roots',
  'kannada hip hop': 'hiphop',
  'kansas city hip hop': 'hiphop',
  'kansas hip hop': 'hiphop',
  'kansas indie': 'indie_alt',
  'kapa haka': 'roots',
  'karadeniz halk muzigi': 'roots',
  'kashmiri pop': 'desi',
  'kawaii edm': 'edm_dance',
  'kawaii future bass': 'edm_dance',
  'kawaii metal': 'j_tracks',
  'kazakh indie': 'pop',
  'kazakh pop': 'pop',
  'kazakh traditional': 'roots',
  'kc indie': 'indie_alt',
  'kelowna bc indie': 'indie_alt',
  'kent indie': 'indie_alt',
  'kentucky hip hop': 'hiphop',
  'kentucky indie': 'indie_alt',
  'kentucky metal': 'metal',
  'kentucky mountain folk': 'folk_americana',
  'kentucky punk': 'punk',
  'kentucky roots': 'folk_americana',
  'kenyan alternative': 'pop',
  'kenyan hip hop': 'hiphop',
  'kenyan pop': 'afro',
  'kenyan traditional': 'roots',
  'khaleeji iraqi': 'pop',
  'kids dance party': 'children',
  'kikuyu gospel': 'inspirational',
  'kikuyu pop': 'afro',
  'kindie rock': 'children',
  'kingston on indie': 'indie_alt',
  'kiwi rock': 'rock',
  'kizomba antigas': 'afro',
  'kleine hoerspiel': 'children',
  'knoxville indie': 'indie_alt',
  'kodomo no ongaku': 'j_tracks',
  'kolkata indie': 'desi',
  'kolsche karneval': 'pop',
  'korean city pop': 'pop',
  'korean classical performance': 'classical',
  'korean classical piano': 'classical',
  'korean contemporary classical': 'classical',
  'korean dream pop': 'pop',
  'korean electronic': 'electronic',
  'korean electropop': 'pop',
  'korean experimental': 'atmospheric',
  'korean hardcore': 'punk',
  'korean indie rock': 'rock',
  'korean jazz': 'jazz',
  'korean mask singer': 'pop',
  'korean metal': 'metal',
  'korean ost': 'pop',
  'korean phantom singer': 'pop',
  'korean pop': 'kpop',
  'korean punk': 'punk',
  'korean r&b': 'rnb',
  'korean superband': 'pop',
  'korean traditional': 'roots',
  'korean trap': 'hiphop',
  'korean worship': 'inspirational',
  'kosovan folk': 'roots',
  'kosovan pop': 'pop',
  'kuduro antigo': 'afro',
  'kurdish folk': 'roots',
  'kurdish hip hop': 'hiphop',
  'kurdish pop': 'pop',
  'kurdish rock': 'rock',
  'kyrgyz pop': 'pop',
  'kyrgyz traditional': 'roots',
  'la indie': 'indie_alt',
  'la pop': 'pop',
  'lafayette indie': 'indie_alt',
  'lancashire indie': 'indie_alt',
  'lancaster pa indie': 'indie_alt',
  'lao traditional': 'roots',
  'late romantic era': 'classical',
  'latin afrobeat': 'afro',
  'latin alternative': 'latin',
  'latin american baroque': 'classical',
  'latin american classical piano': 'classical',
  'latin american heavy psych': 'rock',
  'latin arena pop': 'latin',
  'latin christian': 'inspirational',
  'latin classical': 'classical',
  'latin funk': 'latin',
  'latin hip hop': 'hiphop',
  'latin house': 'edm_dance',
  'latin jazz': 'latin',
  'latin metal': 'metal',
  'latin pop': 'latin',
  'latin rock': 'latin',
  'latin shoegaze': 'latin',
  'latin ska': 'latin',
  'latin soundtrack': 'soundtrack',
  'latin surf rock': 'rock',
  'latin talent show': 'latin',
  'latin tech house': 'edm_dance',
  'latin viral pop': 'latin',
  'latin worship': 'inspirational',
  'latino comedy': 'spoken',
  'latinx alternative': 'latin',
  'latvian electronic': 'electronic',
  'latvian folk': 'roots',
  'latvian hip hop': 'hiphop',
  'latvian indie': 'indie_alt',
  'latvian metal': 'metal',
  'latvian pop': 'pop',
  'latvian rock': 'rock',
  'lawrence ks indie': 'indie_alt',
  'lds youth': 'inspirational',
  'lebanese indie': 'pop',
  'lebanese pop': 'pop',
  'leeds indie': 'indie_alt',
  'leicester indie': 'indie_alt',
  'leipzig electronic': 'electronic',
  'leipzig indie': 'indie_alt',
  'leon gto indie': 'indie_alt',
  'lesotho traditional': 'roots',
  'lexington ky indie': 'indie_alt',
  'lgbtq+ hip hop': 'hiphop',
  'liberian pop': 'afro',
  'library music': 'oldies',
  'light music': 'oldies',
  'limerick indie': 'indie_alt',
  'lincoln ne indie': 'indie_alt',
  'liquid funk': 'edm_dance',
  'lithuanian electronic': 'electronic',
  'lithuanian folk': 'roots',
  'lithuanian hip hop': 'hiphop',
  'lithuanian indie': 'indie_alt',
  'lithuanian metal': 'metal',
  'lithuanian pop': 'pop',
  'lithuanian rock': 'rock',
  'little rock indie': 'indie_alt',
  'liverpool indie': 'indie_alt',
  'lo star': 'indie_alt',
  'lo-fi beats': 'indie_alt',
  'lo-fi brasileiro': 'brazilian',
  'lo-fi chill': 'pop',
  'lo-fi cover': 'electronic',
  'lo-fi emo': 'indie_alt',
  'lo-fi house': 'edm_dance',
  'lo-fi indie': 'indie_alt',
  'lo-fi vgm': 'electronic',
  'lo-fi': 'indie_alt',
  'london indie': 'indie_alt',
  'london on indie': 'indie_alt',
  'london rap': 'hiphop',
  'louisiana blues': 'blues',
  'louisiana metal': 'metal',
  'louisville indie': 'indie_alt',
  'louisville underground': 'indie_alt',
  'lounge house': 'edm_dance',
  'louvor icm': 'inspirational',
  'lovecraftian metal': 'metal',
  'lovers rock': 'reggae',
  'lowlands hardcore': 'punk',
  'luk thung': 'roots',
  'lund indie': 'indie_alt',
  'luxembourgian hip hop': 'hiphop',
  'luxembourgian indie': 'indie_alt',
  'luxembourgian metal': 'metal',
  'macedonian electronic': 'electronic',
  'macedonian folk': 'roots',
  'macedonian indie': 'rock',
  'macedonian pop': 'pop',
  'magyar alternative': 'rock',
  'magyar kabare': 'spoken',
  'magyar mulatos': 'roots',
  'magyar trap': 'hiphop',
  'maine hip hop': 'hiphop',
  'maine indie': 'indie_alt',
  'mainland chinese pop': 'pop',
  'malagasy folk': 'roots',
  'malagasy pop': 'afro',
  'malawian folk': 'roots',
  'malawian pop': 'afro',
  'malay rap': 'hiphop',
  'malayalam hip hop': 'hiphop',
  'malayalam worship': 'inspirational',
  'malaysian hip hop': 'hiphop',
  'malaysian indie': 'pop',
  'malaysian mandopop': 'pop',
  'malaysian metal': 'metal',
  'malaysian pop': 'pop',
  'malaysian punk': 'punk',
  'malaysian tamil pop': 'pop',
  'malian blues': 'pop',
  'malian traditional': 'roots',
  'malmo indie': 'indie_alt',
  'maltese pop': 'pop',
  'mambo chileno': 'latin',
  'manchester hip hop': 'hiphop',
  'manchester indie': 'indie_alt',
  'mande pop': 'afro',
  'manila sound': 'pop',
  'manitoba country': 'country',
  'manitoba indie': 'indie_alt',
  'manso indie': 'indie_alt',
  'marathi pop': 'desi',
  'marathi traditional': 'roots',
  'marcha funebre': 'roots',
  'marching band': 'roots',
  'mariachi cristiano': 'inspirational',
  'marimba de guatemala': 'roots',
  'marimba mexicana': 'roots',
  'marimba orquesta': 'roots',
  'martial industrial': 'electronic',
  'math pop': 'indie_alt',
  'math rock latinoamericano': 'rock',
  'math rock': 'indie_alt',
  'medieval ensemble': 'roots',
  'medieval folk': 'roots',
  'medieval rock': 'rock',
  'medway sound': 'indie_alt',
  'melbourne bounce international': 'edm_dance',
  'melbourne bounce': 'edm_dance',
  'melbourne indie': 'indie_alt',
  'mellow gold': 'rock',
  'melodic black metal': 'metal',
  'melodic death metal': 'metal',
  'melodic deathcore': 'rock',
  'melodic doom': 'metal',
  'melodic dubstep': 'edm_dance',
  'melodic groove metal': 'metal',
  'melodic hard rock': 'rock',
  'melodic hardcore': 'punk',
  'melodic metal': 'metal',
  'melodic metalcore': 'rock',
  'melodic power metal': 'metal',
  'melodic progressive metal': 'metal',
  'melodic rap': 'hiphop',
  'melodic techno': 'edm_dance',
  'melodic thrash': 'metal',
  'meme rap': 'hiphop',
  'memphis americana': 'folk_americana',
  'memphis blues': 'blues',
  'memphis hip hop': 'hiphop',
  'memphis indie': 'indie_alt',
  'memphis soul': 'soul',
  'merengue tipico': 'latin',
  'merida indie': 'indie_alt',
  'messianic praise': 'inspirational',
  'metal baiano': 'brazilian',
  'metal balear': 'metal',
  'metal catala': 'metal',
  'metal catarinense': 'brazilian',
  'metal cearense': 'brazilian',
  'metal colombiano': 'metal',
  'metal cristao': 'inspirational',
  'metal ecuatoriano': 'metal',
  'metal galego': 'metal',
  'metal gaucho': 'brazilian',
  'metal gotico': 'metal',
  'metal guitar': 'metal',
  'metal mineiro': 'brazilian',
  'metal noir quebecois': 'metal',
  'metal nortista': 'brazilian',
  'metal paraguayo': 'metal',
  'metal paranaense': 'brazilian',
  'metal pernambucano': 'brazilian',
  'metal piauiense': 'brazilian',
  'metal salvadoreno': 'metal',
  'metal tico': 'metal',
  'metal uruguayo': 'metal',
  'metalcore espanol': 'rock',
  'metallic hardcore': 'metal',
  'mevlevi sufi': 'roots',
  'mexican black metal': 'metal',
  'mexican classic rock': 'rock',
  'mexican classical': 'classical',
  'mexican death metal': 'metal',
  'mexican edm': 'edm_dance',
  'mexican electronic': 'electronic',
  'mexican experimental': 'atmospheric',
  'mexican hardcore': 'latin',
  'mexican hip hop': 'hiphop',
  'mexican indie': 'latin',
  'mexican metal': 'metal',
  'mexican pop punk': 'latin',
  'mexican pop': 'latin',
  'mexican post-rock': 'rock',
  'mexican power metal': 'metal',
  'mexican rock-and-roll': 'latin',
  'mexican rock': 'latin',
  'mexican son': 'regionalmexican',
  'mexican tech house': 'edm_dance',
  'mexican techno': 'edm_dance',
  'mexican thrash metal': 'metal',
  'mexican traditional': 'regionalmexican',
  'miami bass': 'hiphop',
  'miami hip hop': 'hiphop',
  'miami indie': 'indie_alt',
  'miami metal': 'metal',
  'michigan folk': 'folk_americana',
  'michigan indie': 'indie_alt',
  'middle east hip hop': 'hiphop',
  'middle eastern traditional': 'roots',
  'midwest americana': 'folk_americana',
  'midwest emo': 'rock',
  'milan indie': 'indie_alt',
  'military band': 'roots',
  'military cadence': 'spoken',
  'military rap': 'hiphop',
  'milwaukee hip hop': 'hiphop',
  'milwaukee indie': 'indie_alt',
  'minimal dnb': 'edm_dance',
  'minimal dub': 'edm_dance',
  'minimal dubstep': 'edm_dance',
  'minimal melodic techno': 'edm_dance',
  'minimal synth': 'electronic',
  'minimal tech house': 'edm_dance',
  'minimal techno': 'edm_dance',
  'minimal wave': 'atmospheric',
  'minneapolis indie': 'indie_alt',
  'minneapolis metal': 'metal',
  'minneapolis punk': 'punk',
  'minneapolis sound': 'soul',
  'minnesota hip hop': 'hiphop',
  'mississippi hip hop': 'hiphop',
  'mississippi indie': 'indie_alt',
  'missouri indie': 'indie_alt',
  'mluvene slovo': 'spoken',
  'mod revival': 'rock',
  'modern alternative pop': 'pop',
  'modern alternative rock': 'rock',
  'modern big band': 'jazz',
  'modern blues rock': 'rock',
  'modern blues': 'blues',
  'modern bollywood': 'bollywood',
  'modern country rock': 'country',
  'modern downshift': 'rock',
  'modern dream pop': 'indie_alt',
  'modern electroacoustic': 'electronic',
  'modern enka': 'j_tracks',
  'modern folk rock': 'rock',
  'modern free jazz': 'jazz',
  'modern funk': 'soul',
  'modern hard rock': 'rock',
  'modern indie pop': 'indie_alt',
  'modern jangle pop': 'indie_alt',
  'modern jazz piano': 'jazz',
  'modern jazz trio': 'jazz',
  'modern mod': 'rock',
  'modern old-time': 'folk_americana',
  'modern performance': 'classical',
  'modern power pop': 'rock',
  'modern progressive rock': 'rock',
  'modern psychedelic folk': 'rock',
  'modern reggae': 'reggae',
  'modern rock': 'rock',
  'modern salsa': 'latin',
  'modern ska punk': 'punk',
  'modern southern rock': 'rock',
  'modern string quartet': 'classical',
  'modern swing': 'jazz',
  'modern uplift': 'indie_alt',
  'modular synth': 'electronic',
  'modular techno': 'electronic',
  'moldovan pop': 'pop',
  'mongolian folk': 'roots',
  'mongolian hip hop': 'hiphop',
  'mongolian pop': 'pop',
  'montana indie': 'indie_alt',
  'montana metal': 'metal',
  'montana roots': 'folk_americana',
  'montenegrin pop': 'pop',
  'monterrey indie': 'indie_alt',
  'montreal indie': 'indie_alt',
  'moorish traditional': 'roots',
  'moravian folk': 'roots',
  'morelos indie': 'latin',
  'moroccan pop': 'pop',
  'moroccan traditional': 'roots',
  'mountain dulcimer': 'folk_americana',
  'movie tunes': 'soundtrack',
  'mpb gospel': 'inspirational',
  'mumbai indie': 'desi',
  'munich electronic': 'edm_dance',
  'munich indie': 'indie_alt',
  'murcia indie': 'pop',
  'music box': 'atmospheric',
  'music hall': 'oldies',
  'musica afroperuana': 'roots',
  'musica alagoana': 'brazilian',
  'musica amapaense': 'pop',
  'musica andina colombiana': 'roots',
  'musica andina': 'roots',
  'musica andorra': 'pop',
  'musica angolana': 'roots',
  'musica antigua': 'classical',
  'musica aragonesa': 'pop',
  'musica ayacuchana': 'roots',
  'musica baiana': 'brazilian',
  'musica blumenauense': 'brazilian',
  'musica brasiliense': 'brazilian',
  'musica calabrese': 'pop',
  'musica campineira': 'brazilian',
  'musica campista': 'brazilian',
  'musica canaria': 'pop',
  'musica capixaba': 'brazilian',
  'musica caririense': 'brazilian',
  'musica catalana': 'pop',
  'musica catarinense': 'brazilian',
  'musica cearense': 'brazilian',
  'musica colombiana instrumental': 'latin',
  'musica costarricense': 'latin',
  'musica costena': 'pop',
  'musica crista reformada': 'inspirational',
  'musica cristiana guatemalteca': 'inspirational',
  'musica de fondo': 'background',
  'musica de intervencao': 'pop',
  'musica eletronica brasileira': 'electronic',
  'musica eletronica gospel': 'inspirational',
  'musica etnica': 'roots',
  'musica evangelica instrumental': 'inspirational',
  'musica feirense': 'roots',
  'musica folk asturiana': 'roots',
  'musica gaucha tradicionalista': 'brazilian',
  'musica gaucha': 'brazilian',
  'musica goiana': 'brazilian',
  'musica hondurena': 'pop',
  'musica indigena brasileira': 'brazilian',
  'musica indigena latinoamericana': 'latin',
  'musica indigena mexicana': 'roots',
  'musica infantil catala': 'children',
  'musica infantil': 'children',
  'musica istmena': 'pop',
  'musica jibara': 'roots',
  'musica juiz-forana': 'brazilian',
  'musica llanera': 'roots',
  'musica lombarda': 'pop',
  'musica londrinense': 'brazilian',
  'musica mallorquina': 'pop',
  'musica mapuche': 'latin',
  'musica maranhense': 'brazilian',
  'musica maringaense': 'brazilian',
  'musica mato-grossense': 'brazilian',
  'musica menorquina': 'pop',
  'musica mocambicana': 'roots',
  'musica mogiana': 'brazilian',
  'musica nicaraguense': 'pop',
  'musica occitana': 'roots',
  'musica para criancas': 'children',
  'musica para ninos': 'children',
  'musica paraibana': 'brazilian',
  'musica paranaense': 'brazilian',
  'musica per bambini': 'children',
  'musica pernambucana': 'brazilian',
  'musica piauiense': 'brazilian',
  'musica piemonteisa': 'roots',
  'música pitiusa': 'pop',
  'musica ponta-grossense': 'brazilian',
  'musica popular amazonense': 'brazilian',
  'musica popular colombiana': 'latin',
  'musica popular mineira': 'brazilian',
  'musica popular paraense': 'brazilian',
  'musica popular uruguaya': 'latin',
  'musica portuguesa contemporanea': 'roots',
  'musica potiguar': 'brazilian',
  'musica potosina': 'regionalmexican',
  'musica prehispanica': 'roots',
  'musica puntana': 'pop',
  'musica purepecha': 'roots',
  'musica rapa nui': 'pop',
  'musica rondoniense': 'brazilian',
  'musica roraimense': 'brazilian',
  'musica sarda': 'roots',
  'musica sergipana': 'brazilian',
  'musica sinfonica': 'classical',
  'musica sul-mato-grossense': 'brazilian',
  'musica timor-leste': 'pop',
  'musica tradicional cubana': 'latin',
  'musica triste brasileira': 'brazilian',
  'musica tropical guatemalteca': 'latin',
  'musica valenciana': 'pop',
  'musical advocacy': 'pop',
  'musicas espiritas': 'inspirational',
  'musiikkia lapsille': 'children',
  'musik anak-anak': 'children',
  'musique acadienne': 'pop',
  'musique alsacienne': 'french_variety',
  'musique ancienne': 'classical',
  'musique comorienne': 'pop',
  'musique concrete': 'atmospheric',
  'musique guadeloupe': 'pop',
  'musique mandingue': 'afro',
  'musique mariage algerien': 'pop',
  'musique peule': 'roots',
  'musique pour enfant quebecois': 'children',
  'musique pour enfants': 'children',
  'musique soninke': 'pop',
  'musique touareg': 'roots',
  'musique traditionnelle comorienne': 'roots',
  'musique traditionnelle congolaise': 'roots',
  'muzica copii': 'children',
  'muzica crestina': 'inspirational',
  'muzica populara': 'roots',
  'muziek voor kinderen': 'dutch',
  'myanmar hip hop': 'hiphop',
  'myanmar indie': 'pop',
  'naija worship': 'inspirational',
  'namibian pop': 'afro',
  'nantes indie': 'french_variety',
  'narodna muzika': 'pop',
  'nashville americana': 'folk_americana',
  'nashville hip hop': 'hiphop',
  'nashville indie': 'indie_alt',
  'nashville singer-songwriter': 'folk_americana',
  'nashville sound': 'country',
  'native american contemporary': 'pop',
  'native american flute': 'roots',
  'native american hip hop': 'hiphop',
  'native american spiritual': 'roots',
  'native american': 'roots',
  'neapolitan funk': 'pop',
  'nederlandse hardstyle': 'edm_dance',
  'neo classical metal': 'metal',
  'neo honky tonk': 'country',
  'neo kyma': 'pop',
  'neo mellow': 'pop',
  'neo metal': 'french_variety',
  'neo r&b': 'rnb',
  'neo soul-jazz': 'rnb',
  'neo soul': 'rnb',
  'neo-classical': 'atmospheric',
  'neo-crust': 'punk',
  'neo-industrial rock': 'rock',
  'neo-kraut': 'rock',
  'neo-pagan': 'roots',
  'neo-progressive': 'rock',
  'neo-proto': 'punk',
  'neo-psicodelia brasileira': 'brazilian',
  'neo-psychedelic': 'indie_alt',
  'neo-rockabilly': 'roots',
  'neo-singer-songwriter': 'folk_americana',
  'neo-synthpop': 'indie_alt',
  'neo-trad doom metal': 'metal',
  'neo-trad metal': 'metal',
  'neo-trad prog': 'rock',
  'neo-traditional bluegrass': 'folk_americana',
  'neo-traditional country': 'country',
  'neoclassical darkwave': 'roots',
  'neon pop punk': 'indie_alt',
  'nepali indie': 'pop',
  'nepali pop': 'pop',
  'nerdcore brasileiro': 'brazilian',
  'neue deutsche harte': 'rock',
  'neue deutsche todeskunst': 'edm_dance',
  'neue deutsche welle': 'rock',
  'neue volksmusik': 'pop',
  'new age piano': 'atmospheric',
  'new age': 'atmospheric',
  'new americana': 'folk_americana',
  'new beat': 'edm_dance',
  'new brunswick indie': 'indie_alt',
  'new comedy': 'spoken',
  'new delhi indie': 'desi',
  'new england americana': 'folk_americana',
  'new england emo': 'indie_alt',
  'new england experimental': 'electronic',
  'new french touch': 'electronic',
  'new hampshire indie': 'indie_alt',
  'new isolationism': 'atmospheric',
  'new jack smooth': 'soul',
  'new jack swing': 'rnb',
  'new jersey hardcore': 'punk',
  'new jersey indie': 'indie_alt',
  'new jersey punk': 'punk',
  'new jersey rap': 'hiphop',
  'new mexico music': 'latin',
  'new orleans americana': 'folk_americana',
  'new orleans blues': 'blues',
  'new orleans funk': 'soul',
  'new orleans indie': 'indie_alt',
  'new orleans jazz': 'jazz',
  'new orleans rap': 'hiphop',
  'new rave': 'edm_dance',
  'new romantic': 'indie_alt',
  'new tribe': 'atmospheric',
  'new wave of glam metal': 'rock',
  'new wave of osdm': 'metal',
  'new wave of speed metal': 'metal',
  'new wave of thrash metal': 'metal',
  'new wave pop': 'pop',
  'new wave': 'indie_alt',
  'new weird america': 'folk_americana',
  'new weird finland': 'atmospheric',
  'new york death metal': 'metal',
  'new york drill': 'hiphop',
  'new zealand classical': 'classical',
  'newcastle indie': 'indie_alt',
  'newcastle nsw indie': 'indie_alt',
  'newfoundland indie': 'indie_alt',
  'nice indie': 'french_variety',
  'nigerian hip hop': 'hiphop',
  'nigerian pop': 'pop',
  'nl folk': 'roots',
  'no wave': 'punk',
  'noise pop': 'indie_alt',
  'noise punk': 'punk',
  'noise rock': 'indie_alt',
  'nordic ambient': 'atmospheric',
  'nordic classical piano': 'classical',
  'nordic contemporary classical': 'classical',
  'nordic folk': 'folk_americana',
  'nordic house': 'edm_dance',
  'nordic orchestra': 'classical',
  'nordic post-rock': 'rock',
  'nordic soundtrack': 'soundtrack',
  'norges stemme': 'pop',
  'normal indie': 'indie_alt',
  'norman ok indie': 'indie_alt',
  'norsk lovsang': 'inspirational',
  'norteno-sax': 'regionalmexican',
  'north carolina emo': 'rock',
  'north carolina hip hop': 'hiphop',
  'north carolina indie': 'indie_alt',
  'north carolina metal': 'metal',
  'north carolina roots': 'folk_americana',
  'north dakota indie': 'indie_alt',
  'north east england indie': 'indie_alt',
  'northamptonshire indie': 'indie_alt',
  'northeast indian hip hop': 'hiphop',
  'northeast indian indie': 'desi',
  'northern irish indie': 'indie_alt',
  'northern irish punk': 'punk',
  'northern soul': 'soul',
  'northumbrian folk': 'roots',
  'norwegian alternative rock': 'punk',
  'norwegian americana': 'roots',
  'norwegian black metal': 'metal',
  'norwegian blues': 'blues',
  'norwegian choir': 'roots',
  'norwegian classical': 'classical',
  'norwegian contemporary jazz': 'jazz',
  'norwegian country': 'pop',
  'norwegian death metal': 'metal',
  'norwegian doom metal': 'metal',
  'norwegian experimental': 'atmospheric',
  'norwegian folk': 'roots',
  'norwegian gospel': 'inspirational',
  'norwegian hardcore': 'punk',
  'norwegian hip hop': 'hiphop',
  'norwegian indie': 'pop',
  'norwegian jazz': 'jazz',
  'norwegian metal': 'metal',
  'norwegian pop rap': 'hiphop',
  'norwegian pop': 'pop',
  'norwegian prog': 'rock',
  'norwegian psychedelic': 'rock',
  'norwegian punk rock': 'punk',
  'norwegian punk': 'punk',
  'norwegian rock': 'rock',
  'norwegian singer-songwriter': 'pop',
  'norwegian space disco': 'electronic',
  'norwegian techno': 'edm_dance',
  'norwegian trap': 'hiphop',
  'nottingham indie': 'indie_alt',
  'nouvelle chanson francaise': 'french_variety',
  'nova canco': 'pop',
  'nova mpb': 'brazilian',
  'nova musica amazonense': 'brazilian',
  'nova musica carioca': 'brazilian',
  'nova musica maranhense': 'brazilian',
  'nova musica paulista': 'brazilian',
  'nova musica pernambucana': 'brazilian',
  'novo rock gaucho': 'brazilian',
  'novos talentos brasileiros': 'brazilian',
  'nu age': 'atmospheric',
  'nu disco': 'edm_dance',
  'nu electro': 'edm_dance',
  'nu gaze': 'indie_alt',
  'nu jazz': 'jazz',
  'nu metal': 'rock',
  'nu skool breaks': 'edm_dance',
  'nu-cumbia': 'hiphop',
  'nu-metalcore': 'rock',
  'nubian traditional': 'roots',
  'nueva cancion': 'roots',
  'nueva ola chilena': 'latin',
  'nueva ola peruana': 'latin',
  'nueva trova chilena': 'latin',
  'nuevo flamenco': 'latin',
  'nuevo folklore argentino': 'roots',
  'nuevo folklore mexicano': 'pop',
  'nuevo regional mexicano': 'regionalmexican',
  'nuevo tango': 'pop',
  'ny roots': 'pop',
  'nyc metal': 'metal',
  'nyc pop': 'pop',
  'nyc rap': 'hiphop',
  'nz christian': 'inspirational',
  'nz dnb': 'edm_dance',
  'nz electronic': 'electronic',
  'nz folk': 'folk_americana',
  'nz hardcore': 'punk',
  'nz hip hop': 'hiphop',
  'nz indie': 'indie_alt',
  'nz metal': 'metal',
  'nz pop': 'pop',
  'nz punk': 'punk',
  'nz reggae': 'reggae',
  'nz singer-songwriter': 'roots',
  'oakland hip hop': 'hiphop',
  'oakland indie': 'indie_alt',
  'oaxaca indie': 'indie_alt',
  'oc indie': 'indie_alt',
  'oc rap': 'hiphop',
  'oceania soundtrack': 'soundtrack',
  'ohio hip hop': 'hiphop',
  'ohio indie': 'indie_alt',
  'ok indie': 'indie_alt',
  'okc indie': 'indie_alt',
  'okinawan folk': 'roots',
  'okinawan pop': 'j_tracks',
  'oklahoma country': 'country',
  'old school dancehall': 'reggae',
  'old school hard trance': 'edm_dance',
  'old school hip hop': 'hiphop',
  'old school nederhop': 'hiphop',
  'old school rap francais': 'french_variety',
  'old school thrash': 'metal',
  'old school uk hip hop': 'hiphop',
  'old west': 'soundtrack',
  'old-time fiddle': 'folk_americana',
  'old-time': 'oldies',
  'olympia wa indie': 'indie_alt',
  'omaha indie': 'indie_alt',
  'one-person band': 'indie_alt',
  'ontario indie': 'indie_alt',
  'opera chorus': 'classical',
  'opera metal': 'metal',
  'operatic pop': 'pop',
  'orchestral performance': 'classical',
  'orebro indie': 'pop',
  'organic ambient': 'atmospheric',
  'organic electronic': 'electronic',
  'organic house': 'edm_dance',
  'oriental classical': 'classical',
  'oriental metal': 'metal',
  'orkney and shetland folk': 'roots',
  'orlando indie': 'indie_alt',
  'oromo pop': 'afro',
  'orquesta cubana': 'latin',
  'orquesta tipica': 'roots',
  'orquesta tropical': 'latin',
  'orquestas de galicia': 'roots',
  'orthodox chant': 'roots',
  'oshare kei': 'j_tracks',
  'oslo indie': 'indie_alt',
  'oth indie': 'indie_alt',
  'ottawa indie': 'indie_alt',
  'ottawa rap': 'hiphop',
  'oulu indie': 'pop',
  'oulu metal': 'metal',
  'outer hip hop': 'hiphop',
  'outlaw country': 'country',
  'outsider house': 'atmospheric',
  'oxford choir': 'roots',
  'oxford indie': 'indie_alt',
  'oyun havasi': 'pop',
  'p funk': 'soul',
  'pagan black metal': 'metal',
  'pagode baiano': 'brazilian',
  'pagode novo': 'brazilian',
  'paidika tragoudia': 'children',
  'paisley underground': 'indie_alt',
  'pakistani folk': 'roots',
  'pakistani hip hop': 'hiphop',
  'pakistani indie': 'indie_alt',
  'pakistani pop': 'pop',
  'palestinian pop': 'pop',
  'palm desert scene': 'rock',
  'panamanian indie': 'indie_alt',
  'panamanian pop': 'latin',
  'panamanian rock': 'rock',
  'papuan traditional': 'roots',
  'paraguayan indie': 'indie_alt',
  'paraguayan rock': 'latin',
  'partido alto': 'brazilian',
  'pei indie': 'indie_alt',
  'pennsylvania hardcore': 'punk',
  'permanent wave': 'rock',
  'persian alternative': 'indie_alt',
  'persian hip hop': 'hiphop',
  'persian neo-traditional': 'roots',
  'persian pop': 'pop',
  'persian traditional': 'oldies',
  'perth indie': 'indie_alt',
  'peruvian death metal': 'metal',
  'peruvian experimental': 'latin',
  'peruvian hip hop': 'hiphop',
  'peruvian indie': 'latin',
  'peruvian metal': 'metal',
  'peruvian punk': 'latin',
  'peruvian rock': 'latin',
  'pet calming': 'background',
  'philly indie': 'indie_alt',
  'philly rap': 'hiphop',
  'philly soul': 'soul',
  'phleng phuea chiwit': 'roots',
  'phoenix indie': 'indie_alt',
  'piano blues': 'blues',
  'piano cover': 'background',
  'piano mpb': 'brazilian',
  'piano rock': 'rock',
  'piedmont blues': 'blues',
  'pinoy alternative rap': 'hiphop',
  'pinoy hip hop': 'hiphop',
  'pinoy indie': 'indie_alt',
  'pinoy metal': 'metal',
  'pinoy pop punk': 'punk',
  'pinoy praise': 'inspirational',
  'pinoy r&b': 'rnb',
  'pinoy reggae': 'reggae',
  'pinoy rock': 'rock',
  'pinoy singer-songwriter': 'pop',
  'pinoy traditional': 'roots',
  'pinoy trap': 'hiphop',
  'pittsburgh indie': 'indie_alt',
  'pittsburgh metal': 'metal',
  'pittsburgh rap': 'hiphop',
  'pittsburgh rock': 'rock',
  'plena uruguaya': 'latin',
  'png pop': 'pop',
  'poezja spiewana': 'pop',
  'polca paraguaya': 'roots',
  'police band': 'roots',
  'polish alternative rap': 'hiphop',
  'polish alternative rock': 'rock',
  'polish alternative': 'pop',
  'polish ambient': 'atmospheric',
  'polish black metal': 'metal',
  'polish blues': 'blues',
  'polish choir': 'classical',
  'polish classical piano': 'classical',
  'polish classical': 'classical',
  'polish contemporary classical': 'classical',
  'polish death metal': 'metal',
  'polish early music': 'classical',
  'polish electronica': 'electronic',
  'polish experimental electronic': 'electronic',
  'polish experimental': 'atmospheric',
  'polish folk metal': 'metal',
  'polish folk': 'roots',
  'polish free jazz': 'jazz',
  'polish hardcore': 'punk',
  'polish hip hop': 'hiphop',
  'polish indie rock': 'rock',
  'polish indie': 'indie_alt',
  'polish jazz': 'jazz',
  'polish metal': 'metal',
  'polish modern jazz': 'jazz',
  'polish noise rock': 'rock',
  'polish pop': 'pop',
  'polish post-punk': 'rock',
  'polish post-rock': 'rock',
  'polish prog': 'rock',
  'polish psychedelia': 'pop',
  'polish punk': 'punk',
  'polish reggae': 'reggae',
  'polish rock': 'rock',
  'polish synthpop': 'pop',
  'polish techno': 'edm_dance',
  'polish thrash metal': 'metal',
  'polish trap': 'hiphop',
  'political hip hop': 'hiphop',
  'polynesian hip hop': 'hiphop',
  'polynesian pop': 'pop',
  'polynesian traditional': 'roots',
  'polyphonies corses': 'french_variety',
  'pop ambient': 'atmospheric',
  'pop argentino': 'latin',
  'pop catracho': 'latin',
  'pop chileno': 'latin',
  'pop costarricense': 'latin',
  'pop dance': 'edm_dance',
  'pop edm': 'edm_dance',
  'pop electronico': 'latin',
  'pop emo': 'indie_alt',
  'pop flamenco': 'pop',
  'pop folk': 'folk_americana',
  'pop house': 'edm_dance',
  'pop lgbtq+ brasileira': 'brazilian',
  'pop minang': 'pop',
  'pop nacional antigas': 'brazilian',
  'pop nacional': 'brazilian',
  'pop paraguayo': 'latin',
  'pop peruano': 'latin',
  'pop punk': 'indie_alt',
  'pop quebecois': 'pop',
  'pop r&b': 'rnb',
  'pop rap brasileiro': 'brazilian',
  'pop rap': 'hiphop',
  'pop reggaeton': 'latin',
  'pop rock brasileiro': 'brazilian',
  'pop rock': 'rock',
  'pop romantico': 'latin',
  'pop soul': 'pop',
  'pop teen brasileiro': 'brazilian',
  'pop urbaine': 'french_variety',
  'pop venezolano': 'latin',
  'pop violin': 'pop',
  'pop virale italiano': 'pop',
  'pops orchestra': 'pop',
  'portland hip hop': 'hiphop',
  'portland indie': 'indie_alt',
  'portland metal': 'metal',
  'portland punk': 'punk',
  'portsmouth indie': 'indie_alt',
  'portuguese black metal': 'metal',
  'portuguese contemporary classical': 'classical',
  'portuguese death metal': 'metal',
  'portuguese early music': 'classical',
  'portuguese experimental': 'atmospheric',
  'portuguese folk': 'roots',
  'portuguese indie rock': 'rock',
  'portuguese indie': 'indie_alt',
  'portuguese jazz': 'jazz',
  'portuguese metal': 'metal',
  'portuguese pop': 'pop',
  'portuguese post-rock': 'rock',
  'portuguese rock': 'rock',
  'portuguese techno': 'edm_dance',
  'post-black metal': 'metal',
  'post-disco soul': 'soul',
  'post-disco': 'soul',
  'post-doom metal': 'metal',
  'post-grunge': 'rock',
  'post-hardcore': 'rock',
  'post-metal': 'rock',
  'post-minimalism': 'atmospheric',
  'post-post-hardcore': 'punk',
  'post-punk argentina': 'rock',
  'post-punk brasileiro': 'brazilian',
  'post-punk colombiano': 'latin',
  'post-punk mexicano': 'latin',
  'post-punk': 'punk',
  'post-rock latinoamericano': 'rock',
  'post-rock': 'rock',
  'post-romantic era': 'classical',
  'post-screamo': 'punk',
  'post-teen pop': 'pop',
  'power blues-rock': 'rock',
  'power electronics': 'electronic',
  'power metal': 'metal',
  'power noise': 'edm_dance',
  'power pop': 'indie_alt',
  'power thrash': 'metal',
  'power-pop punk': 'punk',
  'poznan indie': 'pop',
  'prepared piano': 'atmospheric',
  'prog metal': 'metal',
  'prog quebec': 'rock',
  'progressive alternative': 'indie_alt',
  'progressive black metal': 'metal',
  'progressive bluegrass': 'folk_americana',
  'progressive breaks': 'edm_dance',
  'progressive deathcore': 'metal',
  'progressive doom': 'metal',
  'progressive electro house': 'edm_dance',
  'progressive groove metal': 'metal',
  'progressive house': 'edm_dance',
  'progressive jazz fusion': 'jazz',
  'progressive metal': 'metal',
  'progressive metalcore': 'rock',
  'progressive post-hardcore': 'punk',
  'progressive power metal': 'metal',
  'progressive psytrance': 'edm_dance',
  'progressive rock': 'rock',
  'progressive sludge': 'metal',
  'progressive technical death metal': 'metal',
  'progressive thrash': 'metal',
  'progressive trance house': 'edm_dance',
  'progressive trance': 'edm_dance',
  'progressive uplifting trance': 'edm_dance',
  'proto-rap': 'hiphop',
  'proto-techno': 'electronic',
  'psicodelia brasileira': 'brazilian',
  'psicodelia mexicana': 'rock',
  'psych gaze': 'indie_alt',
  'psychedelic blues-rock': 'rock',
  'psychedelic doom': 'metal',
  'psychedelic folk rock': 'rock',
  'psychedelic folk': 'folk_americana',
  'psychedelic hip hop': 'hiphop',
  'psychedelic jazz fusion': 'jazz',
  'psychedelic pop': 'pop',
  'psychedelic punk': 'rock',
  'psychedelic rock': 'rock',
  'psychedelic soul': 'soul',
  'psychedelic space rock': 'rock',
  'psychedelic trance': 'edm_dance',
  'pub rock': 'rock',
  'puerto rican folk': 'roots',
  'puerto rican indie': 'latin',
  'puerto rican metal': 'metal',
  'puerto rican pop': 'latin',
  'puerto rican rock': 'latin',
  'puglia indie': 'indie_alt',
  'pune indie': 'desi',
  'punjabi folk': 'roots',
  'punjabi hip hop': 'hiphop',
  'punjabi pop': 'desi',
  'punk blues': 'punk',
  'punk catala': 'punk',
  'punk chileno': 'punk',
  'punk colombiano': 'latin',
  'punk ecuatoriano': 'punk',
  'punk euskera': 'punk',
  'punk galego': 'punk',
  'punk melodico chileno': 'punk',
  'punk mexicano': 'punk',
  'punk rock italiano': 'punk',
  'punk rock mexicano': 'punk',
  'punk ska': 'punk',
  'punk tico': 'punk',
  'punk tuga': 'punk',
  'punk urbano': 'punk',
  'purple sound': 'electronic',
  'quatuor a cordes': 'classical',
  'quebec death metal': 'metal',
  'quebec indie': 'indie_alt',
  'quebec punk': 'punk',
  'queens hip hop': 'hiphop',
  'queer country': 'country',
  'quiet storm': 'soul',
  'r&b argentino': 'latin',
  'r&b brasileiro': 'brazilian',
  'r&b en espanol': 'latin',
  'r&b italiano': 'pop',
  'r&b': 'rnb',
  'rabindra sangeet': 'pop',
  'radio symphony': 'classical',
  'ragga jungle': 'edm_dance',
  'rajasthani folk': 'roots',
  'rajasthani pop': 'desi',
  'rap abc paulista': 'brazilian',
  'rap alagoano': 'brazilian',
  'rap algerien': 'hiphop',
  'rap angolano': 'hiphop',
  'rap antillais': 'hiphop',
  'rap baiano': 'brazilian',
  'rap baixada fluminense': 'brazilian',
  'rap calme': 'hiphop',
  'rap capixaba': 'brazilian',
  'rap catala': 'hiphop',
  'rap catarinense': 'brazilian',
  'rap cearense': 'brazilian',
  'rap chileno': 'hiphop',
  'rap chretien': 'inspirational',
  'rap conciencia': 'latin',
  'rap conscient': 'french_variety',
  'rap criolo': 'hiphop',
  'rap cristao': 'inspirational',
  'rap cristiano': 'inspirational',
  'rap df': 'brazilian',
  'rap dominicano': 'hiphop',
  'rap ecuatoriano': 'hiphop',
  'rap espanol': 'hiphop',
  'rap euskera': 'hiphop',
  'rap feminino nacional': 'brazilian',
  'rap francais': 'french_variety',
  'rap galego': 'hiphop',
  'rap gaucho': 'brazilian',
  'rap guarulhense': 'brazilian',
  'rap inde': 'french_variety',
  'rap ivoire': 'hiphop',
  'rap kreyol': 'hiphop',
  'rap latina': 'hiphop',
  'rap lyonnais': 'french_variety',
  'rap malien': 'hiphop',
  'rap maroc': 'hiphop',
  'rap maromba': 'brazilian',
  'rap marseille': 'french_variety',
  'rap metal espanol': 'metal',
  'rap metal': 'rock',
  'rap metalcore': 'rock',
  'rap mineiro': 'brazilian',
  'rap montrealais': 'hiphop',
  'rap nacional antigo': 'brazilian',
  'rap napoletano': 'hiphop',
  'rap nortista': 'brazilian',
  'rap paraense': 'brazilian',
  'rap paraguayo': 'hiphop',
  'rap paranaense': 'brazilian',
  'rap pernambucano': 'brazilian',
  'rap potiguar': 'brazilian',
  'rap regio': 'hiphop',
  'rap rock': 'rock',
  'rap salvadoreno': 'hiphop',
  'rap sardegna': 'hiphop',
  'rap sergipano': 'brazilian',
  'rap tico': 'hiphop',
  'rap toscana': 'hiphop',
  'rap tunisien': 'hiphop',
  'rap underground argentino': 'hiphop',
  'rap underground colombiano': 'hiphop',
  'rap underground espanol': 'hiphop',
  'rap underground mexicano': 'hiphop',
  'rap uruguayo': 'hiphop',
  'rare groove': 'soul',
  'rave funk': 'edm_dance',
  'raw black metal': 'metal',
  'raw techno': 'edm_dance',
  're:techno': 'edm_dance',
  'reading indie': 'indie_alt',
  'rebel blues': 'rock',
  'red dirt': 'country',
  'reggae catala': 'reggae',
  'reggae cristao': 'inspirational',
  'reggae en espanol': 'reggae',
  'reggae fusion': 'reggae',
  'reggae gaucho': 'brazilian',
  'reggae mexicano': 'reggae',
  'reggae peruano': 'reggae',
  'reggae rock': 'rock',
  'reggae tico': 'reggae',
  'reggae tuga': 'reggae',
  'reggaeton chileno': 'latin',
  'reggaeton colombiano': 'latin',
  'reggaeton cristiano': 'inspirational',
  'reggaeton flow': 'latin',
  'reggaeton mexicano': 'latin',
  'regional mexican': 'regionalmexican',
  'remix product': 'edm_dance',
  'rennes indie': 'french_variety',
  'retro metal': 'metal',
  'retro soul': 'soul',
  'reunion pop': 'pop',
  'rhode island indie': 'indie_alt',
  'rhode island rap': 'hiphop',
  'rhythm and blues': 'rnb',
  'rhythm and boogie': 'oldies',
  'rhythm game': 'edm_dance',
  'riddim dubstep': 'edm_dance',
  'rio grande do sul indie': 'indie_alt',
  'riot grrrl': 'punk',
  'ritmo kombina': 'pop',
  'ritual ambient': 'atmospheric',
  'rochester mn indie': 'indie_alt',
  'rochester ny indie': 'indie_alt',
  'rock abc paulista': 'brazilian',
  'rock alagoano': 'brazilian',
  'rock alternatif francais': 'french_variety',
  'rock alternativo brasileiro': 'brazilian',
  'rock alternativo espanol': 'rock',
  'rock andaluz': 'rock',
  'rock baiano': 'brazilian',
  'rock brasiliense': 'brazilian',
  'rock caipira': 'brazilian',
  'rock campineiro': 'brazilian',
  'rock catala': 'rock',
  'rock catarinense': 'brazilian',
  'rock catracho': 'latin',
  'rock cearense': 'brazilian',
  'rock chapin': 'rock',
  'rock cristao fluminense': 'inspirational',
  'rock cristiano': 'inspirational',
  'rock curitibano': 'brazilian',
  'rock dominicano': 'rock',
  'rock drums': 'rock',
  'rock en asturiano': 'rock',
  'rock en espanol': 'latin',
  'rock gaucho': 'brazilian',
  'rock goiano': 'brazilian',
  'rock gospel brasileiro': 'inspirational',
  'rock gotico': 'latin',
  'rock in opposition': 'rock',
  'rock independant francais': 'french_variety',
  'rock kapak': 'rock',
  'rock keyboard': 'rock',
  'rock mineiro': 'brazilian',
  'rock nacional brasileiro': 'brazilian',
  'rock nacional feminino': 'brazilian',
  'rock nacional': 'latin',
  'rock nica': 'rock',
  'rock noise': 'rock',
  'rock of gibraltar': 'pop',
  'rock paraense': 'brazilian',
  'rock paraibano': 'brazilian',
  'rock pernambucano': 'brazilian',
  'rock piauiense': 'brazilian',
  'rock potiguar': 'brazilian',
  'rock progresivo mexicano': 'rock',
  'rock progressif francais': 'french_variety',
  'rock quebecois': 'rock',
  'rock sergipano': 'brazilian',
  'rock steady': 'reggae',
  'rock sul-mato-grossense': 'brazilian',
  'rock tico': 'latin',
  'rock urbano mexicano': 'latin',
  'rock uruguayo': 'latin',
  'rock viet': 'rock',
  'rock-and-roll': 'oldies',
  'rockabilly en espanol': 'rock',
  'roda de samba': 'pop',
  'romanian classical piano': 'classical',
  'romanian contemporary classical': 'classical',
  'romanian electronic': 'electronic',
  'romanian folk': 'roots',
  'romanian indie': 'indie_alt',
  'romanian metal': 'metal',
  'romanian pop': 'pop',
  'romanian rap': 'hiphop',
  'romanian rock': 'rock',
  'romanian trap': 'hiphop',
  'rome indie': 'indie_alt',
  'roots americana': 'folk_americana',
  'roots reggae': 'reggae',
  'roots rock': 'rock',
  'roots worship': 'inspirational',
  'rosario indie': 'indie_alt',
  'rotterdam indie': 'indie_alt',
  'rumba catalana': 'roots',
  'rumba congolaise': 'roots',
  'rune folk': 'roots',
  'russian alt pop': 'pop',
  'russian alternative rock': 'indie_alt',
  'russian black metal': 'metal',
  'russian ccm': 'inspirational',
  'russian chanson': 'pop',
  'russian choir': 'roots',
  'russian classical piano': 'classical',
  'russian contemporary classical': 'classical',
  'russian dance pop': 'pop',
  'russian dance': 'pop',
  'russian death metal': 'metal',
  'russian dnb': 'edm_dance',
  'russian drill': 'hiphop',
  'russian edm': 'edm_dance',
  'russian electronic': 'pop',
  'russian emo': 'rock',
  'russian experimental electronic': 'electronic',
  'russian folk metal': 'metal',
  'russian folk rock': 'rock',
  'russian folk': 'roots',
  'russian gangster rap': 'hiphop',
  'russian grime': 'hiphop',
  'russian hardcore': 'punk',
  'russian heavy metal': 'metal',
  'russian hip hop': 'hiphop',
  'russian indie rock': 'rock',
  'russian indie': 'indie_alt',
  'russian jazz': 'jazz',
  'russian metal': 'metal',
  'russian metalcore': 'rock',
  'russian modern classical': 'classical',
  'russian nu metal': 'rock',
  'russian orchestra': 'classical',
  'russian pop punk': 'punk',
  'russian pop': 'pop',
  'russian post-punk': 'rock',
  'russian post-rock': 'rock',
  'russian power metal': 'metal',
  'russian punk rock': 'rock',
  'russian punk': 'punk',
  'russian rave': 'edm_dance',
  'russian reggae': 'reggae',
  'russian rock': 'rock',
  'russian romance': 'pop',
  'russian romanticism': 'classical',
  'russian shoegaze': 'rock',
  'russian ska': 'punk',
  'russian synthpop': 'pop',
  'russian techno': 'edm_dance',
  'russian thrash metal': 'metal',
  'russian trance': 'edm_dance',
  'russian trap': 'hiphop',
  'russian underground rap': 'hiphop',
  'ruta destroy': 'edm_dance',
  'rva indie': 'indie_alt',
  'rwandan gospel': 'inspirational',
  'rwandan hip hop': 'hiphop',
  'rwandan pop': 'afro',
  'rwandan traditional': 'roots',
  'ryukyu ongaku': 'j_tracks',
  'sacramento hip hop': 'hiphop',
  'sacramento indie': 'indie_alt',
  'sacred steel': 'inspirational',
  'sad rap': 'hiphop',
  'salsa choke': 'latin',
  'salsa colombiana': 'latin',
  'salsa cristiana': 'inspirational',
  'salsa cubana': 'latin',
  'salsa international': 'latin',
  'salsa peruana': 'roots',
  'salsa puertorriquena': 'latin',
  'salsa venezolana': 'latin',
  'salzburg indie': 'indie_alt',
  'samba de roda': 'brazilian',
  'samba gospel': 'inspirational',
  'samba moderno': 'brazilian',
  'samba paulista': 'brazilian',
  'samba reggae': 'brazilian',
  'samba-enredo': 'brazilian',
  'samba-jazz': 'brazilian',
  'samba-rock': 'rock',
  'samoan pop': 'pop',
  'san antonio indie': 'indie_alt',
  'san antonio rap': 'hiphop',
  'san diego indie': 'indie_alt',
  'san diego rap': 'hiphop',
  'san marcos tx indie': 'indie_alt',
  'santa fe indie': 'indie_alt',
  'sardinia indie': 'indie_alt',
  'saskatchewan indie': 'indie_alt',
  'scam rap': 'hiphop',
  'scandinavian r&b': 'rnb',
  'school choir': 'roots',
  'schweizer rap': 'hiphop',
  'sci-fi metal': 'metal',
  'scottish americana': 'folk_americana',
  'scottish electronic': 'electronic',
  'scottish fiddle': 'roots',
  'scottish folk': 'roots',
  'scottish gaelic folk': 'roots',
  'scottish hip hop': 'hiphop',
  'scottish indie folk': 'indie_alt',
  'scottish indie rock': 'indie_alt',
  'scottish indie': 'indie_alt',
  'scottish jazz': 'jazz',
  'scottish metal': 'metal',
  'scottish new wave': 'rock',
  'scottish rock': 'rock',
  'scottish singer-songwriter': 'folk_americana',
  'scottish smallpipe': 'roots',
  'scottish techno': 'edm_dance',
  'scream rap': 'hiphop',
  'seattle hip hop': 'hiphop',
  'seattle indie': 'indie_alt',
  'seattle metal': 'metal',
  'second line': 'roots',
  'sega mauricien': 'pop',
  'senegalese traditional': 'roots',
  'serbian alternative rock': 'rock',
  'serbian electronic': 'electronic',
  'serbian folk': 'roots',
  'serbian hip hop': 'hiphop',
  'serbian indie': 'pop',
  'serbian metal': 'metal',
  'sertanejo gospel': 'inspirational',
  'sertanejo pop': 'sertanejo',
  'sertanejo tradicional': 'sertanejo',
  'sertanejo universitario': 'sertanejo',
  'sesotho pop': 'afro',
  'sevilla indie': 'indie_alt',
  'sheffield indie': 'indie_alt',
  'shibuya-kei': 'j_tracks',
  'shimmer pop': 'indie_alt',
  'shimmer psych': 'indie_alt',
  'shiver pop': 'indie_alt',
  'shoegaze brasileiro': 'brazilian',
  'shoegaze chileno': 'rock',
  'show tunes': 'soundtrack',
  'siberian folk': 'roots',
  'sinaloa indie': 'indie_alt',
  'singaporean electronic': 'edm_dance',
  'singaporean hip hop': 'hiphop',
  'singaporean indie': 'indie_alt',
  'singaporean mandopop': 'pop',
  'singaporean metal': 'metal',
  'singaporean pop': 'pop',
  'singaporean punk': 'punk',
  'singaporean singer-songwriter': 'pop',
  'singer-songwriter': 'pop',
  'singing bowl': 'background',
  'sinhala pop': 'pop',
  'sinhala rap': 'hiphop',
  'ska argentino': 'latin',
  'ska catala': 'punk',
  'ska chileno': 'reggae',
  'ska espanol': 'reggae',
  'ska jazz': 'reggae',
  'ska mexicano': 'latin',
  'ska punk': 'punk',
  'ska revival': 'reggae',
  'skate punk': 'punk',
  'skinhead oi': 'punk',
  'sky room': 'edm_dance',
  'slack-key guitar': 'roots',
  'slam death metal': 'metal',
  'slam poetry': 'spoken',
  'slamming deathcore': 'metal',
  'slash punk': 'punk',
  'slavic folk metal': 'metal',
  'slavic metal': 'metal',
  'slc indie': 'indie_alt',
  'sleaze rock': 'rock',
  'slovak electronic': 'electronic',
  'slovak folk': 'roots',
  'slovak hip hop': 'hiphop',
  'slovak indie': 'indie_alt',
  'slovak metal': 'metal',
  'slovak pop': 'pop',
  'slovak rock': 'rock',
  'slovenian electronic': 'electronic',
  'slovenian folk': 'roots',
  'slovenian hip hop': 'hiphop',
  'slovenian indie': 'rock',
  'slovenian metal': 'metal',
  'slovenian pop': 'pop',
  'slovenian rock': 'rock',
  'slow game': 'rnb',
  'sludge metal': 'metal',
  'small room': 'indie_alt',
  'smooth jazz': 'jazz',
  'smooth saxophone': 'jazz',
  'smooth soul': 'soul',
  'smutny rap': 'hiphop',
  'socal indie': 'indie_alt',
  'socal pop punk': 'punk',
  'social media pop': 'pop',
  'soda pop': 'oldies',
  'soft rock': 'rock',
  'solomon islands pop': 'pop',
  'somali pop': 'afro',
  'somatik techno': 'edm_dance',
  'son cubano clasico': 'roots',
  'son cubano': 'roots',
  'son jarocho': 'roots',
  'song poem': 'oldies',
  'sonora indie': 'indie_alt',
  'sophisti-pop': 'pop',
  'soul blues': 'blues',
  'soul flow': 'rnb',
  'soul jazz': 'jazz',
  'sound art': 'atmospheric',
  'sound collage': 'atmospheric',
  'sound effects': 'background',
  'sound team': 'j_tracks',
  'south african alternative': 'indie_alt',
  'south african choral': 'roots',
  'south african country': 'country',
  'south african electronic': 'electronic',
  'south african gospel': 'inspirational',
  'south african hip hop': 'hiphop',
  'south african house': 'edm_dance',
  'south african jazz': 'jazz',
  'south african metal': 'metal',
  'south african pop dance': 'edm_dance',
  'south african pop': 'afro',
  'south african punk': 'punk',
  'south african rock': 'rock',
  'south african trap': 'hiphop',
  'south asian metal': 'metal',
  'south carolina hip hop': 'hiphop',
  'south carolina indie': 'indie_alt',
  'south carolina metal': 'metal',
  'south dakota indie': 'indie_alt',
  'south sudanese pop': 'afro',
  'southampton indie': 'indie_alt',
  'southeast asian post-rock': 'rock',
  'southern americana': 'folk_americana',
  'southern gospel': 'inspirational',
  'southern hip hop': 'hiphop',
  'southern metal': 'metal',
  'southern rock': 'rock',
  'southern soul blues': 'soul',
  'southern soul': 'soul',
  'soviet synthpop': 'pop',
  'space age pop': 'oldies',
  'space ambient': 'atmospheric',
  'space rock': 'rock',
  'spanish baroque': 'classical',
  'spanish black metal': 'metal',
  'spanish blues': 'blues',
  'spanish classical piano': 'classical',
  'spanish classical': 'classical',
  'spanish contemporary classical': 'classical',
  'spanish death metal': 'metal',
  'spanish electronic': 'electronic',
  'spanish electropop': 'electronic',
  'spanish experimental': 'atmospheric',
  'spanish folk metal': 'metal',
  'spanish folk rock': 'rock',
  'spanish folk': 'roots',
  'spanish hip hop': 'hiphop',
  'spanish indie folk': 'pop',
  'spanish indie pop': 'indie_alt',
  'spanish indie rock': 'indie_alt',
  'spanish invasion': 'oldies',
  'spanish jazz': 'latin',
  'spanish metal': 'metal',
  'spanish modern rock': 'rock',
  'spanish new wave': 'indie_alt',
  'spanish noise pop': 'indie_alt',
  'spanish pop rock': 'pop',
  'spanish pop': 'latin',
  'spanish post-punk': 'rock',
  'spanish post-rock': 'rock',
  'spanish prog': 'rock',
  'spanish progressive rock': 'rock',
  'spanish psychedelic rock': 'rock',
  'spanish punk': 'punk',
  'spanish reggae': 'reggae',
  'spanish renaissance': 'classical',
  'spanish rock': 'rock',
  'spanish rockabilly': 'rock',
  'spanish stoner rock': 'rock',
  'spanish synthpop': 'pop',
  'spanish techno': 'edm_dance',
  'speed garage': 'edm_dance',
  'speed metal': 'metal',
  'spiritual hip hop': 'hiphop',
  'spiritual jazz': 'jazz',
  'spoken word': 'spoken',
  'springfield mo indie': 'indie_alt',
  'st louis rap': 'hiphop',
  'st petersburg fl indie': 'indie_alt',
  'stateside dnb': 'edm_dance',
  'steel guitar': 'roots',
  'stl indie': 'indie_alt',
  'stockholm indie': 'indie_alt',
  'stomp and flutter': 'folk_americana',
  'stomp and holler': 'indie_alt',
  'stomp and whittle': 'folk_americana',
  'stomp pop': 'indie_alt',
  'stoner metal': 'metal',
  'stoner rock': 'rock',
  'straight edge': 'punk',
  'straight-ahead jazz': 'jazz',
  'street band': 'roots',
  'street punk espanol': 'punk',
  'street punk': 'punk',
  'string band': 'oldies',
  'string folk': 'folk_americana',
  'string orchestra': 'classical',
  'string quartet': 'classical',
  'stuttgart indie': 'indie_alt',
  'sudanese pop': 'pop',
  'sufi chant': 'roots',
  'sundanese traditional': 'roots',
  'sung poetry': 'oldies',
  'sunset lounge': 'background',
  'sunshine pop': 'pop',
  'suomi rock': 'rock',
  'surf music': 'oldies',
  'surf punk': 'indie_alt',
  'surinamese pop': 'pop',
  'svensk indie': 'rock',
  'svensk lovsang': 'inspirational',
  'svensk progg': 'rock',
  'swahili gospel': 'inspirational',
  'swamp blues': 'blues',
  'swamp pop': 'roots',
  'swamp rock': 'rock',
  'swansea indie': 'indie_alt',
  'swedish alternative rock': 'indie_alt',
  'swedish americana': 'pop',
  'swedish black metal': 'metal',
  'swedish blues': 'blues',
  'swedish choir': 'roots',
  'swedish classical': 'classical',
  'swedish contemporary classical': 'classical',
  'swedish country': 'pop',
  'swedish dancehall': 'pop',
  'swedish death metal': 'metal',
  'swedish doom metal': 'metal',
  'swedish electronic': 'electronic',
  'swedish electropop': 'pop',
  'swedish emo': 'rock',
  'swedish eurodance': 'pop',
  'swedish experimental': 'atmospheric',
  'swedish fiddle': 'roots',
  'swedish folk pop': 'pop',
  'swedish gangsta rap': 'hiphop',
  'swedish garage rock': 'rock',
  'swedish grindcore': 'metal',
  'swedish hard rock': 'rock',
  'swedish hardcore': 'punk',
  'swedish heavy metal': 'metal',
  'swedish hip hop': 'hiphop',
  'swedish house': 'edm_dance',
  'swedish idol pop': 'pop',
  'swedish indie folk': 'pop',
  'swedish indie pop': 'pop',
  'swedish indie rock': 'rock',
  'swedish jazz orkester': 'jazz',
  'swedish jazz': 'jazz',
  'swedish melodic rock': 'rock',
  'swedish metal': 'metal',
  'swedish metalcore': 'rock',
  'swedish pop punk': 'punk',
  'swedish pop': 'pop',
  'swedish post-hardcore': 'rock',
  'swedish post-punk': 'rock',
  'swedish power metal': 'metal',
  'swedish prog': 'rock',
  'swedish progressive metal': 'metal',
  'swedish psychedelic rock': 'rock',
  'swedish punk': 'punk',
  'swedish reggae': 'reggae',
  'swedish rock-and-roll': 'rock',
  'swedish rockabilly': 'rock',
  'swedish singer-songwriter': 'pop',
  'swedish soul': 'soul',
  'swedish stoner rock': 'rock',
  'swedish synth': 'electronic',
  'swedish synthpop': 'indie_alt',
  'swedish techno': 'edm_dance',
  'swedish trap pop': 'pop',
  'swedish trap': 'hiphop',
  'swedish tropical house': 'edm_dance',
  'swedish underground rap': 'hiphop',
  'swing italiano': 'pop',
  'swing revival': 'oldies',
  'swiss alternative rock': 'rock',
  'swiss black metal': 'metal',
  'swiss classical piano': 'classical',
  'swiss contemporary classical': 'classical',
  'swiss country': 'pop',
  'swiss experimental': 'atmospheric',
  'swiss folk': 'roots',
  'swiss hip hop': 'hiphop',
  'swiss house': 'edm_dance',
  'swiss indie folk': 'pop',
  'swiss indie': 'indie_alt',
  'swiss jazz': 'jazz',
  'swiss metal': 'metal',
  'swiss pop': 'pop',
  'swiss punk': 'punk',
  'swiss reggae': 'reggae',
  'swiss rock': 'rock',
  'swiss singer-songwriter': 'pop',
  'swiss techno': 'edm_dance',
  'swiss trap': 'hiphop',
  'swiss worship': 'inspirational',
  'sydney indie': 'indie_alt',
  'symphonic black metal': 'metal',
  'symphonic death metal': 'metal',
  'symphonic melodic death metal': 'metal',
  'symphonic metal': 'metal',
  'symphonic power metal': 'metal',
  'symphonic rock': 'rock',
  'synth funk': 'soul',
  'synth punk': 'punk',
  'synthwave brasileiro': 'brazilian',
  'syrian pop': 'pop',
  'syro-aramaic chant': 'inspirational',
  'tagalog rap': 'hiphop',
  'tagalog worship': 'inspirational',
  'taiwan campus folk': 'pop',
  'taiwan classical performance': 'roots',
  'taiwan electronic': 'edm_dance',
  'taiwan experimental': 'atmospheric',
  'taiwan hip hop': 'hiphop',
  'taiwan indie': 'pop',
  'taiwan instrumental': 'roots',
  'taiwan metal': 'metal',
  'taiwan pop': 'pop',
  'taiwan punk': 'punk',
  'taiwan rock': 'rock',
  'taiwan singer-songwriter': 'pop',
  'taiwanese indie': 'pop',
  'taiwanese indigenous': 'pop',
  'taiwanese pop': 'pop',
  'tajik pop': 'pop',
  'tajik traditional': 'roots',
  'talent show': 'pop',
  'talentos brasileiros': 'brazilian',
  'tamaulipas indie': 'pop',
  'tamaulipas rap': 'hiphop',
  'tamil hip hop': 'hiphop',
  'tamil pop': 'desi',
  'tamil worship': 'inspirational',
  'tampa indie': 'indie_alt',
  'tango cancion': 'latin',
  'tanzanian pop': 'afro',
  'tanzanian traditional': 'roots',
  'tape club': 'indie_alt',
  'tassie indie': 'indie_alt',
  'tatar folk': 'roots',
  'tatar pop': 'pop',
  'tech house': 'edm_dance',
  'tech trance': 'edm_dance',
  'technical black metal': 'metal',
  'technical brutal death metal': 'metal',
  'technical death metal': 'metal',
  'technical deathcore': 'metal',
  'technical grindcore': 'metal',
  'technical groove metal': 'metal',
  'technical melodic death metal': 'metal',
  'technical thrash': 'metal',
  'techno argentina': 'edm_dance',
  'techno kayo': 'j_tracks',
  'techno rave': 'edm_dance',
  'teen pop': 'pop',
  'telugu hip hop': 'hiphop',
  'telugu indie': 'desi',
  'telugu worship': 'inspirational',
  'tempe indie': 'indie_alt',
  'tennessee experimental': 'atmospheric',
  'tennessee hip hop': 'hiphop',
  'tennessee metal': 'metal',
  'tex-mex': 'regionalmexican',
  'texas blues': 'blues',
  'texas country': 'country',
  'texas hardcore': 'punk',
  'texas latin rap': 'hiphop',
  'texas pop punk': 'punk',
  'texas punk': 'punk',
  'thai folk pop': 'pop',
  'thai folk rock': 'rock',
  'thai folk': 'pop',
  'thai hip hop': 'hiphop',
  'thai idol': 'pop',
  'thai indie pop': 'pop',
  'thai indie rock': 'rock',
  'thai indie': 'indie_alt',
  'thai instrumental': 'roots',
  'thai metal': 'metal',
  'thai pop': 'pop',
  'thai rock': 'rock',
  'thai traditional': 'roots',
  'thai trap': 'hiphop',
  'thrash core': 'punk',
  'thrash metal': 'metal',
  'thrash-groove metal': 'metal',
  'throat singing': 'roots',
  'tibetan mantra': 'roots',
  'tibetan pop': 'pop',
  'tibetan traditional': 'roots',
  'tijuana electronic': 'latin',
  'tijuana indie': 'indie_alt',
  'tin pan alley': 'oldies',
  'togolese pop': 'afro',
  'tolkien metal': 'metal',
  'tongan pop': 'pop',
  'torch song': 'jazz',
  'toronto indie': 'indie_alt',
  'toronto rap': 'hiphop',
  'trad jazz catala': 'jazz',
  'trad quebecois': 'roots',
  'traditional bluegrass': 'folk_americana',
  'traditional blues': 'blues',
  'traditional british folk': 'roots',
  'traditional country': 'country',
  'traditional english folk': 'roots',
  'traditional folk': 'folk_americana',
  'traditional funk': 'soul',
  'traditional irish singing': 'roots',
  'traditional reggae': 'reggae',
  'traditional rockabilly': 'oldies',
  'traditional scottish folk': 'roots',
  'traditional ska': 'reggae',
  'traditional soul': 'soul',
  'trance brasileiro': 'edm_dance',
  'trance mexicano': 'edm_dance',
  'trap argentino': 'hiphop',
  'trap baiano': 'brazilian',
  'trap brasileiro': 'brazilian',
  'trap carioca': 'brazilian',
  'trap catala': 'hiphop',
  'trap chileno': 'hiphop',
  'trap colombiano': 'hiphop',
  'trap cristao': 'inspirational',
  'trap cristiano': 'inspirational',
  'trap dominicano': 'hiphop',
  'trap funk': 'brazilian',
  'trap italiana': 'hiphop',
  'trap latino': 'hiphop',
  'trap metal italiana': 'hiphop',
  'trap mexicano': 'hiphop',
  'trap peruano': 'hiphop',
  'trap pesado': 'brazilian',
  'trap queen': 'hiphop',
  'trap soul': 'rnb',
  'trap triste': 'hiphop',
  'trap tuga': 'hiphop',
  'trap venezolano': 'hiphop',
  'trash rock': 'rock',
  'triangle indie': 'indie_alt',
  'tribal house': 'edm_dance',
  'trinidadian reggae': 'reggae',
  'trio batak': 'roots',
  'trio cubano': 'latin',
  'trio huasteco': 'regionalmexican',
  'trip hop': 'edm_dance',
  'trombone brasileiro': 'brazilian',
  'trondheim indie': 'indie_alt',
  'tropical house': 'edm_dance',
  'trova mexicana': 'pop',
  'truck-driving country': 'country',
  'tuareg guitar': 'afro',
  'tucson indie': 'indie_alt',
  'tulsa indie': 'indie_alt',
  'tuna estudiantil': 'roots',
  'tunisian pop': 'pop',
  'turbo folk': 'pop',
  'turin indie': 'indie_alt',
  'turkish alt pop': 'pop',
  'turkish alternative rock': 'rock',
  'turkish alternative': 'indie_alt',
  'turkish black metal': 'metal',
  'turkish classical performance': 'classical',
  'turkish classical': 'roots',
  'turkish edm': 'edm_dance',
  'turkish electronic': 'electronic',
  'turkish experimental': 'atmospheric',
  'turkish folk': 'roots',
  'turkish hip hop': 'hiphop',
  'turkish instrumental': 'roots',
  'turkish jazz': 'jazz',
  'turkish metal': 'metal',
  'turkish modern jazz': 'jazz',
  'turkish pop': 'pop',
  'turkish psych': 'pop',
  'turkish punk': 'punk',
  'turkish reggae': 'reggae',
  'turkish rock': 'rock',
  'turkish singer-songwriter': 'pop',
  'turkish soundtrack': 'soundtrack',
  'turkish trap pop': 'pop',
  'turkish trap': 'hiphop',
  'twee indie pop': 'indie_alt',
  'twee pop': 'indie_alt',
  'twin cities indie': 'indie_alt',
  'uae indie': 'indie_alt',
  'ugandan pop': 'afro',
  'ugandan traditional': 'roots',
  'uilleann pipes': 'roots',
  'uk alternative hip hop': 'hiphop',
  'uk alternative pop': 'pop',
  'uk americana': 'folk_americana',
  'uk beatdown': 'punk',
  'uk christian rap': 'inspirational',
  'uk contemporary jazz': 'jazz',
  'uk contemporary r&b': 'rnb',
  'uk dance': 'edm_dance',
  'uk dancehall': 'reggae',
  'uk diy punk': 'punk',
  'uk dnb': 'edm_dance',
  'uk doom metal': 'metal',
  'uk drill': 'hiphop',
  'uk dub': 'reggae',
  'uk experimental electronic': 'electronic',
  'uk funky': 'edm_dance',
  'uk garage': 'edm_dance',
  'uk hip hop': 'hiphop',
  'uk house': 'edm_dance',
  'uk metalcore': 'rock',
  'uk noise rock': 'indie_alt',
  'uk pop punk': 'punk',
  'uk pop': 'pop',
  'uk post-hardcore': 'punk',
  'uk post-metal': 'metal',
  'uk post-punk revival': 'rock',
  'uk post-punk': 'punk',
  'uk reggae': 'reggae',
  'uk rockabilly': 'rock',
  'uk stoner rock': 'rock',
  'uk tech house': 'edm_dance',
  'uk worship': 'inspirational',
  'ukg revival': 'edm_dance',
  'ukrainian black metal': 'metal',
  'ukrainian choir': 'roots',
  'ukrainian classical piano': 'classical',
  'ukrainian classical': 'classical',
  'ukrainian electronic': 'electronic',
  'ukrainian experimental': 'atmospheric',
  'ukrainian folk': 'roots',
  'ukrainian hip hop': 'hiphop',
  'ukrainian indie': 'indie_alt',
  'ukrainian metal': 'metal',
  'ukrainian pop': 'pop',
  'ukrainian rock': 'rock',
  'ulkucu sarkilar': 'pop',
  'umea indie': 'indie_alt',
  'unblack metal': 'inspirational',
  'underground hip hop': 'hiphop',
  'underground power pop': 'indie_alt',
  'underground rap': 'hiphop',
  'university choir': 'roots',
  'uplifting trance': 'edm_dance',
  'uppsala indie': 'pop',
  'uptempo hardcore': 'edm_dance',
  'urban contemporary': 'rnb',
  'urbano espanol': 'hiphop',
  'uruguayan indie': 'indie_alt',
  'us power metal': 'metal',
  'utah indie': 'indie_alt',
  'utah metal': 'metal',
  'uyghur folk': 'roots',
  'uzbek pop': 'pop',
  'uzbek traditional': 'roots',
  'v-pop': 'pop',
  'vaikiskos dainos': 'children',
  'vallenato moderno': 'latin',
  'vancouver indie': 'indie_alt',
  'vancouver metal': 'metal',
  'vancouver punk': 'punk',
  'vanuatu music': 'pop',
  'vapor house': 'edm_dance',
  'vapor pop': 'indie_alt',
  'vapor soul': 'indie_alt',
  'vapor trap': 'hiphop',
  'vapor twitch': 'edm_dance',
  'variete francaise': 'french_variety',
  'vegan straight edge': 'punk',
  'vegas indie': 'indie_alt',
  'velha guarda': 'brazilian',
  'venezuelan hip hop': 'hiphop',
  'venezuelan indie': 'indie_alt',
  'venezuelan metal': 'metal',
  'venezuelan rock': 'latin',
  'veracruz indie': 'latin',
  'vermont indie': 'indie_alt',
  'vgm instrumental': 'soundtrack',
  'vgm remix': 'electronic',
  'victoria bc indie': 'indie_alt',
  'victorian britain': 'classical',
  'video game music': 'electronic',
  'vienna indie': 'indie_alt',
  'vietnamese bolero': 'roots',
  'vietnamese hip hop': 'hiphop',
  'vietnamese pop': 'pop',
  'vietnamese singer-songwriter': 'pop',
  'vietnamese traditional': 'roots',
  'viking black metal': 'metal',
  'viking folk': 'roots',
  'viking metal': 'metal',
  'vintage chanson': 'oldies',
  'vintage chinese pop': 'pop',
  'vintage classical singing': 'classical',
  'vintage country folk': 'oldies',
  'vintage dutch pop': 'pop',
  'vintage finnish jazz': 'jazz',
  'vintage french electronic': 'french_variety',
  'vintage gospel': 'inspirational',
  'vintage hawaiian': 'roots',
  'vintage hollywood': 'oldies',
  'vintage italian pop': 'oldies',
  'vintage italian soundtrack': 'oldies',
  'vintage jazz': 'jazz',
  'vintage old-time': 'oldies',
  'vintage radio show': 'spoken',
  'vintage reggae': 'reggae',
  'vintage rockabilly': 'oldies',
  'vintage schlager': 'oldies',
  'vintage spanish pop': 'pop',
  'vintage swedish pop': 'oldies',
  'vintage swing': 'oldies',
  'vintage swoon': 'oldies',
  'vintage tango': 'oldies',
  'vintage western': 'oldies',
  'viola caipira': 'brazilian',
  'viola da gamba': 'classical',
  'violao classico': 'classical',
  'viral pop brasileiro': 'brazilian',
  'viral pop': 'pop',
  'viral rap': 'hiphop',
  'viral trap': 'hiphop',
  'virgin islands reggae': 'reggae',
  'virginia hip hop': 'hiphop',
  'virginia indie': 'indie_alt',
  'virginia metal': 'metal',
  'virginia punk': 'punk',
  'visual kei': 'j_tracks',
  'vlaamse cabaret': 'comedy',
  'vlaamse kinderliedje': 'children',
  'vlaamse rap': 'hiphop',
  'vocal ensemble': 'classical',
  'vocal harmony group': 'oldies',
  'vocal house': 'edm_dance',
  'vocal jazz': 'jazz',
  'vocal trance': 'edm_dance',
  'volkstumliche musik': 'roots',
  'waiata maori': 'roots',
  'war metal': 'metal',
  'warm drone': 'atmospheric',
  'warrington indie': 'indie_alt',
  'washington indie': 'indie_alt',
  'wellington indie': 'indie_alt',
  'welsh choir': 'roots',
  'welsh folk': 'roots',
  'welsh hip hop': 'hiphop',
  'welsh indie': 'indie_alt',
  'welsh metal': 'metal',
  'welsh rock': 'rock',
  'west african jazz': 'jazz',
  'west australian hip hop': 'hiphop',
  'west coast rap': 'hiphop',
  'west coast reggae': 'reggae',
  'west coast trap': 'hiphop',
  'west end': 'pop',
  'west virginia indie': 'indie_alt',
  'west virginia metal': 'metal',
  'west yorkshire indie': 'indie_alt',
  'west-vlaamse hip hop': 'hiphop',
  'western americana': 'folk_americana',
  'western mass indie': 'indie_alt',
  'western ny metal': 'metal',
  'western saharan folk': 'roots',
  'western swing': 'country',
  'whale song': 'background',
  'white noise': 'background',
  'wind ensemble': 'classical',
  'wind quintet': 'classical',
  'wind symphony': 'classical',
  'windsor on indie': 'indie_alt',
  'winnipeg hip hop': 'hiphop',
  'wisconsin indie': 'indie_alt',
  'wisconsin metal': 'metal',
  'witch house': 'atmospheric',
  'worcester ma indie': 'indie_alt',
  'workout product': 'edm_dance',
  'world chill': 'background',
  'world fusion': 'roots',
  'world meditation': 'background',
  'world worship': 'inspirational',
  'wu fam': 'hiphop',
  'wuhan indie': 'pop',
  'wyoming indie': 'indie_alt',
  'wyoming roots': 'folk_americana',
  'xtra raw': 'edm_dance',
  'yacht rock': 'rock',
  'ye ye': 'french_variety',
  'yemeni pop': 'pop',
  'yemeni traditional': 'roots',
  'yiddish folk': 'roots',
  'york indie': 'indie_alt',
  'yorkshire folk': 'folk_americana',
  'youth orchestra': 'classical',
  'yugoslav new wave': 'pop',
  'yugoslav rock': 'rock',
  'yunnan traditional': 'roots',
  'zambian hip hop': 'hiphop',
  'zambian pop': 'afro',
  'zespol dzieciecy': 'children',
  'zhongguo feng': 'pop',
  'zim gospel': 'inspirational',
  'zim hip hop': 'hiphop',
  'zim urban groove': 'afro',
  'zouk riddim': 'roots',
  'zurich indie': 'indie_alt',
  "australian children's music": 'children',
  "black 'n' roll": 'metal',
  "british children's music": 'children',
  "canadian children's music": 'children',
  "canzone d'autore": 'pop',
  "children's choir": 'roots',
  "children's folk": 'children',
  "children's music": 'children',
  "children's story": 'children',
  "death 'n' roll": 'metal',
  "men's choir": 'roots',
  "min'yo": 'j_tracks',
  "muzika l'yeladim": 'children',
  "preschool children's music": 'children',
  "punk 'n' roll": 'punk',
  "quartetto d'archi": 'classical',
  "women's choir": 'roots',
  "women's music": 'folk_americana',
  abstract: 'atmospheric',
  abstractro: 'atmospheric',
  accordeon: 'roots',
  accordion: 'roots',
  acidcore: 'edm_dance',
  acousmatic: 'atmospheric',
  adoracao: 'inspirational',
  adoracion: 'inspirational',
  adventista: 'inspirational',
  afrikaans: 'afro',
  afrobeat: 'afro',
  afrofuturism: 'afro',
  afropop: 'afro',
  afroswing: 'hiphop',
  aggrotech: 'edm_dance',
  ai: 'pop',
  alphorn: 'roots',
  alte: 'afro',
  amapiano: 'electronic',
  ambeat: 'atmospheric',
  ambient: 'atmospheric',
  anime: 'j_tracks',
  antideutsche: 'punk',
  arabesk: 'roots',
  asakaa: 'hiphop',
  asmr: 'background',
  atmosphere: 'background',
  aussietronica: 'indie_alt',
  austindie: 'indie_alt',
  austropop: 'pop',
  autoharp: 'folk_americana',
  axe: 'brazilian',
  azonto: 'hiphop',
  azontobeats: 'hiphop',
  bachata: 'latin',
  baglama: 'roots',
  bagpipe: 'roots',
  bahai: 'roots',
  baiao: 'brazilian',
  bajki: 'children',
  balafon: 'roots',
  balalaika: 'roots',
  balearic: 'edm_dance',
  balfolk: 'roots',
  ballroom: 'oldies',
  banda: 'regionalmexican',
  bandinhas: 'brazilian',
  bandolim: 'brazilian',
  bandoneon: 'roots',
  bangla: 'roots',
  banjo: 'roots',
  bansuri: 'roots',
  barbershop: 'oldies',
  bard: 'pop',
  barnalog: 'children',
  barnasogur: 'children',
  barnemusikk: 'children',
  barnmusik: 'children',
  barnsagor: 'children',
  barockinterpreten: 'classical',
  baroque: 'classical',
  basshall: 'pop',
  bassline: 'edm_dance',
  batak: 'roots',
  batida: 'edm_dance',
  beatboxing: 'hiphop',
  beatdown: 'punk',
  beatlesque: 'rock',
  beats: 'edm_dance',
  bebop: 'jazz',
  bells: 'atmospheric',
  bemani: 'j_tracks',
  benga: 'roots',
  bhajan: 'roots',
  bhangra: 'roots',
  bible: 'inspirational',
  bikutsi: 'roots',
  binaural: 'background',
  birdsong: 'atmospheric',
  bisrock: 'rock',
  bitpop: 'electronic',
  blackgaze: 'metal',
  blaskapelle: 'roots',
  blasmusik: 'roots',
  bloco: 'brazilian',
  bluegrass: 'folk_americana',
  blues: 'blues',
  bmore: 'edm_dance',
  boeremusiek: 'roots',
  bolero: 'latin',
  boogaloo: 'latin',
  boogie: 'soul',
  bornesange: 'children',
  bounce: 'hiphop',
  bouzouki: 'roots',
  bozlak: 'roots',
  braindance: 'electronic',
  breakbeat: 'edm_dance',
  breakcore: 'edm_dance',
  breaks: 'edm_dance',
  brega: 'brazilian',
  britpop: 'indie_alt',
  broadway: 'soundtrack',
  brostep: 'edm_dance',
  bubblegrunge: 'indie_alt',
  byzantine: 'roots',
  c64: 'indie_alt',
  c86: 'indie_alt',
  cabaret: 'oldies',
  cajun: 'roots',
  calypso: 'reggae',
  candombe: 'roots',
  candomble: 'brazilian',
  cantaditas: 'edm_dance',
  cantautor: 'roots',
  cantopop: 'pop',
  capoeira: 'brazilian',
  carimbo: 'brazilian',
  carnatic: 'roots',
  carnaval: 'oldies',
  cartoon: 'children',
  ccm: 'inspirational',
  cedm: 'inspirational',
  ceilidh: 'roots',
  celtic: 'roots',
  chakra: 'background',
  chalga: 'pop',
  chamame: 'brazilian',
  champeta: 'colombian',
  chanson: 'french_variety',
  charanga: 'latin',
  charango: 'roots',
  chicha: 'latin',
  chilena: 'regionalmexican',
  chillhop: 'hiphop',
  chillstep: 'edm_dance',
  chillwave: 'indie_alt',
  chinderlieder: 'children',
  chiptune: 'electronic',
  choral: 'classical',
  choro: 'brazilian',
  christelijk: 'inspirational',
  chunchaca: 'regionalmexican',
  chutney: 'latin',
  cifteli: 'roots',
  cimbalom: 'roots',
  circuit: 'edm_dance',
  circus: 'roots',
  classical: 'classical',
  classify: 'pop',
  coco: 'brazilian',
  coldwave: 'electronic',
  comedia: 'spoken',
  comedienne: 'spoken',
  comedy: 'spoken',
  comic: 'comedy',
  complextro: 'edm_dance',
  concertina: 'roots',
  contrabass: 'classical',
  convent: 'inspirational',
  copla: 'pop',
  corrido: 'regionalmexican',
  corrosion: 'electronic',
  country: 'country',
  coverchill: 'background',
  covertrance: 'edm_dance',
  cowpunk: 'punk',
  crunk: 'hiphop',
  cuarteto: 'latin',
  cubaton: 'latin',
  cumbia: 'latin',
  cybergrind: 'electronic',
  cyberpunk: 'electronic',
  cymraeg: 'pop',
  dabke: 'pop',
  dancehall: 'reggae',
  dangdut: 'pop',
  dansband: 'dansband',
  danseband: 'pop',
  dansktop: 'danish',
  danspunk: 'pop',
  darbuka: 'roots',
  darkstep: 'edm_dance',
  darksynth: 'electronic',
  deathcore: 'metal',
  deathgrass: 'country',
  deathgrind: 'metal',
  deathrash: 'metal',
  deathrock: 'rock',
  deathstep: 'edm_dance',
  dembow: 'latin',
  demoscene: 'atmospheric',
  dhrupad: 'roots',
  didgeridoo: 'atmospheric',
  disco: 'soul',
  discofox: 'pop',
  disney: 'children',
  dixieland: 'oldies',
  dizi: 'roots',
  djembe: 'roots',
  djent: 'metal',
  dombra: 'roots',
  doomcore: 'edm_dance',
  doujin: 'j_tracks',
  downtempo: 'edm_dance',
  draaiorgel: 'roots',
  dragspel: 'roots',
  drama: 'spoken',
  dreamgaze: 'indie_alt',
  dreamo: 'indie_alt',
  drift: 'atmospheric',
  drill: 'hiphop',
  drone: 'atmospheric',
  dronescape: 'atmospheric',
  drumfunk: 'edm_dance',
  dub: 'reggae',
  dubstep: 'edm_dance',
  dubsteppe: 'edm_dance',
  duduk: 'roots',
  duranguense: 'regionalmexican',
  dweilorkest: 'roots',
  e6fi: 'indie_alt',
  easycore: 'punk',
  ebm: 'edm_dance',
  ectofolk: 'folk_americana',
  edm: 'edm_dance',
  electra: 'electronic',
  electro: 'electronic',
  electroclash: 'punk',
  electrofox: 'pop',
  electronica: 'edm_dance',
  electronicore: 'punk',
  electropop: 'pop',
  electropowerpop: 'indie_alt',
  elektropunk: 'electronic',
  emo: 'rock',
  emocore: 'rock',
  emoviolence: 'punk',
  enka: 'j_tracks',
  entehno: 'roots',
  environmental: 'background',
  epicore: 'soundtrack',
  erhu: 'roots',
  erotica: 'spoken',
  esperanto: 'pop',
  etherpop: 'indie_alt',
  ethnomusicology: 'roots',
  ethnotronica: 'electronic',
  euphonium: 'roots',
  eurobeat: 'edm_dance',
  eurodance: 'edm_dance',
  europop: 'pop',
  euroska: 'punk',
  eurovision: 'pop',
  exotica: 'oldies',
  experimental: 'atmospheric',
  fado: 'pop',
  filmi: 'bollywood',
  filthstep: 'edm_dance',
  fingerstyle: 'folk_americana',
  fisarmonica: 'roots',
  flamenco: 'roots',
  fluxwork: 'atmospheric',
  focus: 'background',
  folclorica: 'colombian',
  folk: 'folk_americana',
  folkmusik: 'roots',
  folktronica: 'electronic',
  footwork: 'edm_dance',
  forro: 'brazilian',
  francoton: 'french_variety',
  frauenrap: 'hiphop',
  freakbeat: 'oldies',
  freestyle: 'pop',
  frenchcore: 'french_variety',
  frevo: 'brazilian',
  fuji: 'roots',
  funana: 'afro',
  funk: 'soul',
  futurepop: 'electronic',
  gabba: 'edm_dance',
  gaita: 'roots',
  galego: 'roots',
  gamecore: 'punk',
  gamelan: 'roots',
  gayageum: 'roots',
  gbvfi: 'indie_alt',
  gengetone: 'hiphop',
  ghazal: 'roots',
  ghettotech: 'edm_dance',
  ghoststep: 'edm_dance',
  glass: 'atmospheric',
  glitch: 'atmospheric',
  glitchcore: 'hiphop',
  gnawa: 'roots',
  goralski: 'roots',
  goregrind: 'metal',
  gospel: 'inspirational',
  gothabilly: 'rock',
  gqom: 'edm_dance',
  grime: 'hiphop',
  grimewave: 'electronic',
  grindcore: 'metal',
  griot: 'roots',
  grunge: 'rock',
  grupera: 'latin',
  guaracha: 'edm_dance',
  guggenmusik: 'roots',
  guidance: 'spoken',
  gumbe: 'pop',
  guqin: 'roots',
  guzheng: 'roots',
  gwoka: 'roots',
  gyerekdalok: 'children',
  gymcore: 'rock',
  gypsy: 'roots',
  h8000: 'punk',
  hakkapop: 'pop',
  handbells: 'atmospheric',
  hangoskonyvek: 'spoken',
  hangpan: 'atmospheric',
  hardcore: 'punk',
  hardingfele: 'roots',
  hardstyle: 'edm_dance',
  hardvapour: 'atmospheric',
  harmonikka: 'roots',
  harp: 'roots',
  harpsichord: 'classical',
  hatecore: 'punk',
  hauntology: 'atmospheric',
  hawaiian: 'roots',
  healing: 'background',
  highlife: 'afro',
  hiplife: 'hiphop',
  hoerspiel: 'spoken',
  hollywood: 'soundtrack',
  hopebeat: 'indie_alt',
  horrorcore: 'hiphop',
  house: 'edm_dance',
  huapango: 'regionalmexican',
  huayno: 'roots',
  hula: 'pop',
  humppa: 'pop',
  hyperpop: 'electronic',
  hyphy: 'hiphop',
  hypnosis: 'spoken',
  idol: 'pop',
  ilahiler: 'roots',
  illbient: 'electronic',
  impressionism: 'classical',
  indiecoustica: 'indie_alt',
  indietronica: 'indie_alt',
  indorock: 'dutch',
  industrial: 'electronic',
  iskelma: 'pop',
  italogaze: 'rock',
  jamgrass: 'folk_americana',
  jamtronica: 'electronic',
  japanoise: 'atmospheric',
  jawaiian: 'reggae',
  jazz: 'jazz',
  jazztronica: 'electronic',
  joropo: 'roots',
  judaica: 'roots',
  jugendchor: 'roots',
  juju: 'afro',
  jumpstyle: 'edm_dance',
  jumptek: 'edm_dance',
  jungle: 'edm_dance',
  kabarett: 'pop',
  kabyle: 'roots',
  kaneka: 'roots',
  kantele: 'roots',
  karaoke: 'background',
  karneval: 'pop',
  kaseko: 'roots',
  kavkaz: 'pop',
  kayokyoku: 'j_tracks',
  keroncong: 'roots',
  khaliji: 'roots',
  khmer: 'pop',
  kinderchor: 'children',
  kinderliedjies: 'children',
  kindermusik: 'children',
  kirtan: 'roots',
  kizomba: 'afro',
  klapa: 'roots',
  kleinkunst: 'pop',
  klezmer: 'roots',
  komedi: 'comedy',
  kompa: 'latin',
  kora: 'roots',
  koto: 'roots',
  krautrock: 'rock',
  kritika: 'roots',
  kuduro: 'edm_dance',
  kundiman: 'pop',
  kwaito: 'hiphop',
  laboratorio: 'atmospheric',
  laiko: 'roots',
  landler: 'roots',
  language: 'spoken',
  latin: 'latin',
  latincore: 'latin',
  latintronica: 'indie_alt',
  lds: 'inspirational',
  lesen: 'spoken',
  levenslied: 'roots',
  lezginka: 'roots',
  liedermacher: 'roots',
  lilith: 'pop',
  livetronica: 'electronic',
  lldm: 'inspirational',
  lounge: 'oldies',
  louvor: 'inspirational',
  lowercase: 'atmospheric',
  lullaby: 'children',
  lustrum: 'pop',
  lute: 'classical',
  madchester: 'rock',
  madrigal: 'classical',
  maghreb: 'arabic',
  mahraganat: 'edm_dance',
  makina: 'edm_dance',
  makossa: 'roots',
  mallet: 'atmospheric',
  maloya: 'roots',
  mambo: 'latin',
  mandible: 'atmospheric',
  mandolin: 'folk_americana',
  mandopop: 'pop',
  manele: 'pop',
  manguebeat: 'brazilian',
  mantra: 'background',
  maracatu: 'brazilian',
  mariachi: 'regionalmexican',
  marimba: 'atmospheric',
  marrabenta: 'roots',
  mashup: 'edm_dance',
  maskandi: 'roots',
  massage: 'background',
  mathcore: 'punk',
  mathgrind: 'punk',
  mbalax: 'roots',
  mbira: 'roots',
  medieval: 'classical',
  medimeisterschaften: 'pop',
  meditation: 'background',
  melancholia: 'indie_alt',
  melodipop: 'pop',
  mento: 'roots',
  merengue: 'latin',
  merseybeat: 'oldies',
  mestissatge: 'pop',
  metal: 'metal',
  metalcore: 'rock',
  metropopolis: 'indie_alt',
  mezmur: 'inspirational',
  microhouse: 'edm_dance',
  microtonal: 'atmospheric',
  mindfulness: 'background',
  minecraft: 'indie_alt',
  minimalism: 'classical',
  minnesang: 'classical',
  mizrahi: 'roots',
  molam: 'pop',
  mollywood: 'desi',
  moog: 'electronic',
  moombahton: 'edm_dance',
  morna: 'roots',
  motivation: 'spoken',
  motown: 'soul',
  mpb: 'brazilian',
  multidisciplinary: 'pop',
  mundart: 'pop',
  murga: 'roots',
  musikkorps: 'roots',
  naat: 'roots',
  nasheed: 'roots',
  nasyid: 'roots',
  navajo: 'roots',
  necrogrind: 'metal',
  nederpop: 'oldies',
  neoclassicism: 'classical',
  neofolk: 'roots',
  neomelodici: 'pop',
  neotango: 'latin',
  nephop: 'hiphop',
  nerdcore: 'hiphop',
  neurofunk: 'edm_dance',
  neurostep: 'edm_dance',
  ngoni: 'roots',
  nightcore: 'edm_dance',
  nightrun: 'rock',
  ninja: 'edm_dance',
  nintendocore: 'electronic',
  nisiotika: 'roots',
  nitzhonot: 'edm_dance',
  nohay: 'roots',
  noise: 'atmospheric',
  noisecore: 'rock',
  norteno: 'regionalmexican',
  novelty: 'comedy',
  nursery: 'children',
  nwobhm: 'metal',
  nwocr: 'rock',
  nwothm: 'metal',
  nyahbinghi: 'reggae',
  nyckelharpa: 'roots',
  nyhc: 'punk',
  oberkrainer: 'roots',
  oi: 'punk',
  oktoberfest: 'roots',
  opera: 'classical',
  operetta: 'classical',
  opm: 'pop',
  oratory: 'spoken',
  orchestra: 'classical',
  organetto: 'roots',
  orgcore: 'punk',
  ostrock: 'rock',
  otacore: 'indie_alt',
  oud: 'roots',
  outsider: 'roots',
  pagode: 'brazilian',
  panpipe: 'roots',
  papuri: 'inspirational',
  paracana: 'roots',
  parody: 'comedy',
  partyschlager: 'pop',
  pasodobles: 'roots',
  perreo: 'latin',
  phonk: 'hiphop',
  piada: 'spoken',
  pianissimo: 'background',
  pibroch: 'roots',
  pilates: 'background',
  pipa: 'roots',
  piseiro: 'brazilian',
  pixie: 'indie_alt',
  poetry: 'spoken',
  polka: 'roots',
  polyphony: 'roots',
  pony: 'indie_alt',
  pop: 'pop',
  popgaze: 'indie_alt',
  popwave: 'electronic',
  pornogrind: 'metal',
  porro: 'colombian',
  powerviolence: 'punk',
  powwow: 'roots',
  praise: 'inspirational',
  prank: 'comedy',
  protopunk: 'rock',
  psalmen: 'inspirational',
  psybass: 'electronic',
  psybreaks: 'edm_dance',
  psychill: 'atmospheric',
  psychobilly: 'punk',
  psychokore: 'hiphop',
  psydub: 'electronic',
  psytech: 'edm_dance',
  punjabi: 'punjabi',
  punk: 'punk',
  punta: 'latin',
  qawwali: 'roots',
  quebecois: 'francophone',
  queercore: 'indie_alt',
  quran: 'roots',
  raggatek: 'edm_dance',
  ragtime: 'oldies',
  rai: 'arabic',
  rakugo: 'j_tracks',
  ranchera: 'latin',
  rap: 'hiphop',
  rautalanka: 'rock',
  rave: 'edm_dance',
  rawstyle: 'edm_dance',
  reading: 'spoken',
  rebetiko: 'roots',
  recorder: 'classical',
  redneck: 'country',
  reggae: 'reggae',
  reggaeton: 'latin',
  reiki: 'background',
  relaxative: 'background',
  renaissance: 'classical',
  riddim: 'reggae',
  rif: 'arabic',
  ringtone: 'background',
  rkt: 'latin',
  rock: 'rock',
  rockabilly: 'oldies',
  romantico: 'oldies',
  rominimal: 'electronic',
  rosary: 'inspirational',
  rumba: 'latin',
  russelater: 'pop',
  ryukoka: 'j_tracks',
  salay: 'roots',
  salsa: 'latin',
  samba: 'brazilian',
  sambass: 'brazilian',
  sami: 'roots',
  sandalwood: 'desi',
  sanfona: 'brazilian',
  santur: 'roots',
  sarangi: 'roots',
  sarod: 'roots',
  scandipop: 'pop',
  schlager: 'pop',
  schranz: 'edm_dance',
  scorecore: 'electronic',
  screamo: 'rock',
  screamocore: 'punk',
  sefardi: 'roots',
  sega: 'roots',
  semba: 'roots',
  serialism: 'classical',
  sertanejo: 'sertanejo',
  sevdah: 'roots',
  sevillanas: 'roots',
  shaabi: 'pop',
  shabad: 'roots',
  shakuhachi: 'roots',
  shamanic: 'roots',
  shamisen: 'j_tracks',
  shanty: 'roots',
  shantykoren: 'roots',
  sheilat: 'pop',
  shoegaze: 'indie_alt',
  sholawat: 'roots',
  shred: 'rock',
  shush: 'background',
  sierreno: 'regionalmexican',
  sinogaze: 'rock',
  sitar: 'roots',
  ska: 'reggae',
  skiffle: 'oldies',
  skramz: 'punk',
  skweee: 'edm_dance',
  slayer: 'metal',
  sleep: 'background',
  slowcore: 'indie_alt',
  sludgecore: 'metal',
  soca: 'latin',
  solipsynthm: 'indie_alt',
  sotalaulut: 'pop',
  soukous: 'roots',
  soul: 'soul',
  souldies: 'soul',
  sound: 'background',
  soundtrack: 'soundtrack',
  sovietwave: 'pop',
  spa: 'background',
  spacewave: 'electronic',
  speedcore: 'edm_dance',
  spirituals: 'folk_americana',
  spytrack: 'soundtrack',
  starogradska: 'pop',
  steampunk: 'punk',
  steelpan: 'roots',
  streektaal: 'rock',
  streichquartett: 'classical',
  stride: 'jazz',
  strut: 'pop',
  stubenmusik: 'roots',
  substep: 'edm_dance',
  sufi: 'roots',
  sungura: 'pop',
  suomirap: 'hiphop',
  suomisaundi: 'electronic',
  supergroup: 'rock',
  swancore: 'rock',
  swing: 'jazz',
  synthpop: 'indie_alt',
  synthwave: 'edm_dance',
  szanty: 'roots',
  tabla: 'roots',
  tahitian: 'roots',
  taiko: 'roots',
  tallava: 'pop',
  tamborazo: 'roots',
  tamburica: 'roots',
  tanci: 'spoken',
  tango: 'roots',
  tanzlmusi: 'roots',
  tar: 'roots',
  taraneem: 'inspirational',
  tarantella: 'roots',
  tavern: 'folk_americana',
  techno: 'edm_dance',
  tecnobanda: 'regionalmexican',
  tecnobrega: 'brazilian',
  tejano: 'regionalmexican',
  tekk: 'edm_dance',
  tekno: 'edm_dance',
  terrorcore: 'edm_dance',
  thall: 'metal',
  theme: 'soundtrack',
  therapy: 'background',
  theremin: 'electronic',
  timba: 'latin',
  tipico: 'roots',
  tollywood: 'desi',
  tone: 'background',
  trallalero: 'roots',
  trance: 'edm_dance',
  trancecore: 'rock',
  transpop: 'pop',
  trap: 'hiphop',
  traprun: 'edm_dance',
  trecento: 'classical',
  trekkspill: 'roots',
  tribute: 'pop',
  trikiti: 'roots',
  trival: 'edm_dance',
  tropical: 'latin',
  tropicalia: 'brazilian',
  trot: 'pop',
  troubadour: 'classical',
  trouvere: 'classical',
  trova: 'roots',
  tuna: 'roots',
  turntablism: 'hiphop',
  twoubadou: 'pop',
  tzadik: 'roots',
  uk82: 'punk',
  ukhc: 'punk',
  ukulele: 'roots',
  umbanda: 'brazilian',
  usbm: 'metal',
  uwielbienie: 'inspirational',
  vallenato: 'colombian',
  vaporwave: 'atmospheric',
  vaqueiro: 'brazilian',
  vaudeville: 'oldies',
  vbs: 'inspirational',
  veena: 'roots',
  via: 'pop',
  vikingarock: 'punk',
  villancicos: 'roots',
  viola: 'classical',
  violao: 'brazilian',
  violin: 'classical',
  visor: 'roots',
  vispop: 'pop',
  vocaloid: 'j_tracks',
  vogue: 'pop',
  voidgaze: 'metal',
  voidgrind: 'metal',
  volksmusik: 'roots',
  volkspop: 'pop',
  wandelweiser: 'atmospheric',
  washboard: 'folk_americana',
  wassoulou: 'roots',
  water: 'background',
  wave: 'edm_dance',
  weightless: 'electronic',
  wonky: 'edm_dance',
  world: 'roots',
  worship: 'inspirational',
  wrock: 'indie_alt',
  xhosa: 'pop',
  yodeling: 'country',
  yoga: 'background',
  yoik: 'roots',
  zampogna: 'roots',
  zen: 'background',
  zeuhl: 'rock',
  zikir: 'roots',
  zillertal: 'roots',
  zimdancehall: 'pop',
  zither: 'roots',
  zolo: 'rock',
  zouglou: 'roots',
  zouk: 'roots',
  zydeco: 'roots',
};
